(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $06588c507189b8b5$exports = {};
$06588c507189b8b5$exports = "@import \"https://fonts.bunny.net/css?family=roboto:400\";.root{--background:#0007;--font-family:roboto,sans-serif;--loader-color:#fffd;--loader-size:6em;--loader-border-width:4px;--loader-animation-speed:1s;--ctrls-color:#fff;--ctrls-color-lite:#fff5;--ctrls-background-color:#333d;--ctrls-bar-height:.45em;--ctrls-btn-color:#fff;--ctrls-btn-color-lite:#fff8;--ctrls-btn-left:initial;--ctrls-btn-right:0;--ctrls-btn-top:initial;--ctrls-btn-bottom:0;--video-ratio:calc(16/9);--video-progression:0%;--video-volume:0%}.root,.root *{box-sizing:border-box}.root{min-height:inherit;font-family:var(--font-family);background-color:var(--background);width:100%;height:100%;position:relative;overflow:hidden}.root[controls] .ctrls{display:flex}.ctrls{z-index:3;color:var(--ctrls-color);background-color:var(--ctrls-background-color);flex-direction:row;align-items:center;width:100%;padding:1em .5em;transition:transform .25s;display:none;position:absolute;bottom:0;left:0;transform:translateY(100%)}.root:hover .ctrls{transition-delay:0s;transform:translateY(0%)}.ctrls button{cursor:pointer;background:0 0;border:none;margin:0 1em;padding:0;line-height:1em}.ctrls button svg{vertical-align:middle;width:1.5em;height:1.5em}.ctrls button svg path{fill:var(--ctrls-color)}.ctrls .ctrls-play{cursor:pointer;display:block}.ctrls .ctrls-pause{cursor:pointer;display:none}.root.playing .ctrls .ctrls-play{display:none}.root.playing .ctrls .ctrls-pause{display:block}.ctrls .ctrls-mute{cursor:pointer;display:block}.ctrls .ctrls-unmute{cursor:pointer;display:none}.root.muted .ctrls .ctrls-mute{display:none}.root.muted .ctrls .ctrls-unmute{display:block}.ctrls .ctrls-progress,.ctrls .ctrls-volume{height:var(--ctrls-bar-height);justify-content:center;align-items:center;margin:0 .5em;display:flex;position:relative}.ctrls .ctrls-progress:before,.ctrls .ctrls-volume:before{content:\"\";cursor:pointer;height:var(--ctrls-bar-height);border:1px solid var(--ctrls-color-lite);border-radius:calc(var(--ctrls-bar-height)/2);width:100%;display:block}.ctrls .ctrls-progress:after,.ctrls .ctrls-volume:after{content:\"\";width:var(--video-progression);border-radius:calc(var(--ctrls-bar-height)/2);background:var(--ctrls-color);height:100%;display:block;position:absolute;top:0;left:0}.ctrls .ctrls-progress{width:100%}.ctrls .ctrls-progress:after{width:var(--video-progression)}.ctrls .ctrls-volume{width:4em}.ctrls .ctrls-volume:after{width:var(--video-volume)}.root[controls=btn] .ctrls-progress,.root[controls=btn] .ctrls-volume{display:none}.root[controls=btn] .ctrls{left:var(--ctrls-btn-left);right:var(--ctrls-btn-right);top:var(--ctrls-btn-top);bottom:var(--ctrls-btn-bottom);background:0 0;width:auto;transform:none}.root[controls=btn] .ctrls button svg{font-size:1.5em}.root[controls=btn] .ctrls button svg path{fill:var(--ctrls-btn-color-lite)}.root[controls=btn] .ctrls button:hover svg path{fill:var(--ctrls-btn-color)}.root[gdpr] .gdpr{display:block}.gdpr{z-index:4;color:#fff7;background:linear-gradient(135deg,#0706243e 0%,#07062400 23%,#0000 66%,#1303213b 100%);display:none;position:absolute;top:0;bottom:0;left:0;right:0}.root[loading] .loader,.root[looping] .loader,.root[seeking] .loader{display:inline-block}.loader{z-index:5;width:var(--loader-size);padding-bottom:var(--loader-size);display:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.loader:before,.loader:after{content:\"\";border:var(--loader-border-width)solid var(--loader-color);opacity:1;animation:loader var(--loader-animation-speed)cubic-bezier(0,.2,.8,1)infinite;border-radius:50%;display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.loader:after{animation-delay:calc(-.5*var(--loader-animation-speed))}@keyframes loader{0%{opacity:0;width:0;height:0}4.9%{opacity:0;width:0;height:0}5%{opacity:1;width:0;height:0}to{opacity:0;width:100%;height:100%}}.placeholder{z-index:1;background-position:50%;background-size:cover;display:block;position:absolute;top:0;bottom:0;left:0;right:0}.root[ready] .video{opacity:1}.video{opacity:0;z-index:2;-webkit-user-select:none;user-select:none;position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden}.video .wrapper{pointer-events:none;width:100%;height:100%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)rotate3d(1,1,1,.01deg)scale(1.01)}.video .wrapper .embed{isolation:isolate}.video .wrapper .embed,.video .wrapper .embed iframe,.video .wrapper .embed video{background:0 0;border:none;width:100%;height:100%}";


class $5a22d87987052892$export$2e2bcd8739ae039 {
    // registration methods
    registerEvent(eventName, callback) {
        if (typeof callback === "function") {
            if (!this.events[eventName]) this.events[eventName] = new Set();
            this.events[eventName].add(callback);
        }
    }
    unregisterEvent(eventName, callback) {
        if (this.events[eventName]) this.events[eventName].delete(callback);
    }
    // trigger event
    fireEvent(eventName, data) {
        if (this.events[eventName]) this.events[eventName].forEach((function(callback, index) {
            callback(data, {
                eventSource: this.eventSource,
                eventName: eventName,
                data: data
            });
        }).bind(this));
    }
    constructor(eventSource){
        this.eventSource = eventSource;
        this.events = new Set();
    }
}


class $3adfe98124662902$export$2881499e37b75b9a {
    getEmbed() {
        var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
        if ((_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id) {
            var _this_HTMLElement_settings_embed1, _this_HTMLElement_settings1, _this_HTMLElement1;
            const embed = document.createElement("div");
            embed.setAttribute("part", "embed");
            embed.setAttribute("class", "embed");
            const video = document.createElement("video");
            video.setAttribute("part", "video");
            video.setAttribute("class", "video");
            const source = document.createElement("source");
            source.setAttribute("part", "source");
            source.setAttribute("class", "source");
            source.setAttribute("src", (_this_HTMLElement1 = this.HTMLElement) === null || _this_HTMLElement1 === void 0 ? void 0 : (_this_HTMLElement_settings1 = _this_HTMLElement1.settings) === null || _this_HTMLElement_settings1 === void 0 ? void 0 : (_this_HTMLElement_settings_embed1 = _this_HTMLElement_settings1.embed) === null || _this_HTMLElement_settings_embed1 === void 0 ? void 0 : _this_HTMLElement_settings_embed1.id);
            video.appendChild(source);
            video.addEventListener("timeupdate", this.progressObserver.bind(this));
            embed.appendChild(video);
            this.player = video;
            this.fire("ready");
            return embed;
        } else return false;
    }
    async progressObserver() {
        if (this.getDuration() == 0) return 0;
        let p = 100 * await this.getCurrentTime() / await this.getDuration();
        if (p !== this.__progress) {
            this.__progress = p;
            this.fire("progressChange");
        }
    }
    async getRatio() {
        if (this.player) {
            let w = await this.player.videoWidth;
            let h = await this.player.videoHeight;
            return w / h;
        }
        return;
    }
    async getDuration() {
        if (this.player) return this.player.duration;
        return 0;
    }
    async playing() {
        if (this.player) return !this.player.paused;
    }
    async play() {
        if (this.player) this.player.play();
    }
    async pause() {
        if (this.player) this.player.pause();
    }
    async getCurrentTime() {
        if (this.player) return this.player.currentTime;
    }
    async setCurrentTime(seconds) {
        if (this.player) this.player.currentTime = seconds;
    }
    async setVolume(volume) {
        if (this.player) {
            this.player.volume = volume / 100;
            this.player.muted = 0;
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async getVolume() {
        if (this.player) return this.player.muted ? 0 : this.player.volume * 100;
        return 0;
    }
    async mute() {
        if (this.player) {
            this.player.muted = 1;
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async unMute() {
        if (this.player) {
            this.player.muted = 0;
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    on(eventName, callback) {
        this.events.registerEvent(eventName, callback);
    }
    off(eventName, callback) {
        this.events.unregisterEvent(eventName, callback);
    }
    fire(eventName, data) {
        this.events.fireEvent(eventName, data);
    }
    constructor(HTMLElement){
        this.type = "Native";
        this.HTMLElement = HTMLElement;
        this.events = new (0, $5a22d87987052892$export$2e2bcd8739ae039)(this);
        this.player = null;
        // private state
        this.__started = null;
        this.__progress = 0;
    }
}
var $3adfe98124662902$export$2e2bcd8739ae039 = $3adfe98124662902$export$2881499e37b75b9a;



class $15607a07c80ee7b5$export$2881499e37b75b9a {
    getEmbed() {
        var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
        if ((_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id) {
            var _this_HTMLElement_settings_embed1, _this_HTMLElement_settings1, _this_HTMLElement1;
            const embed = document.createElement("div");
            embed.setAttribute("part", "embed");
            embed.setAttribute("class", "embed");
            const sdk = document.createElement("script");
            sdk.setAttribute("src", "https://www.youtube.com/iframe_api");
            embed.appendChild(sdk);
            const iframe = document.createElement("iframe");
            iframe.setAttribute("part", "iframe");
            iframe.setAttribute("class", "iframe");
            iframe.setAttribute("type", "text/html");
            iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture; encrypted-media; accelerometer; gyroscope");
            iframe.setAttribute("src", `https://www.youtube.com/embed/${(_this_HTMLElement1 = this.HTMLElement) === null || _this_HTMLElement1 === void 0 ? void 0 : (_this_HTMLElement_settings1 = _this_HTMLElement1.settings) === null || _this_HTMLElement_settings1 === void 0 ? void 0 : (_this_HTMLElement_settings_embed1 = _this_HTMLElement_settings1.embed) === null || _this_HTMLElement_settings_embed1 === void 0 ? void 0 : _this_HTMLElement_settings_embed1.id}?mute=1&autoplay=1&cc_load_policy=0&enablejsapi=1&iv_load_policy=3&modestbranding=1&showinfo=0&controls=0`);
            embed.appendChild(iframe);
            var youtubeApiWatcher = setInterval(()=>{
                var _YT;
                if (typeof YT !== "undefined" && typeof ((_YT = YT) === null || _YT === void 0 ? void 0 : _YT.Player) === "function") {
                    clearInterval(youtubeApiWatcher);
                    this.player = new YT.Player(iframe);
                    this.player.addEventListener("onReady", ()=>{
                        this.fire("ready");
                    });
                    setInterval(this.progressObserver.bind(this), 50);
                }
            }, 100);
            return embed;
        } else return false;
    }
    async destroyPlayer() {
        if (this.player && typeof this.player.destroy === "function") this.player.destroy();
    }
    async progressObserver() {
        if (this.getDuration() == 0) return 0;
        let p = 100 * await this.getCurrentTime() / await this.getDuration();
        if (isNaN(p)) return 0;
        if (p !== this.__progress) {
            this.__progress = p;
            this.fire("progressChange");
        }
    }
    async getRatio() {
        var _this_HTMLElement_settings, _this_HTMLElement;
        return (_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : _this_HTMLElement_settings.embed.ratio;
    }
    async getDuration() {
        if (this.player && typeof this.player.getDuration === "function") return this.player.getDuration();
        return 0;
    }
    async playing() {
        if (this.player) return this.player.getPlayerState() == YT.PlayerState.PLAYING;
    }
    async play() {
        if (this.player) this.player.playVideo();
    }
    async pause() {
        if (this.player) this.player.pauseVideo();
    }
    async getCurrentTime() {
        if (this.player && typeof this.player.getCurrentTime === "function") return await this.player.getCurrentTime();
    }
    async setCurrentTime(seconds) {
        if (this.player) this.player.seekTo(seconds);
    }
    async setVolume(volume) {
        if (this.player) {
            this.player.setVolume(volume);
            this.player.unMute();
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async getVolume() {
        if (this.player) return this.player.isMuted() ? 0 : this.player.getVolume();
        return 0;
    }
    async mute() {
        if (this.player) {
            this.player.mute();
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async unMute() {
        if (this.player) {
            this.player.unMute();
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    on(eventName, callback) {
        this.events.registerEvent(eventName, callback);
    }
    off(eventName, callback) {
        this.events.unregisterEvent(eventName, callback);
    }
    fire(eventName, data) {
        this.events.fireEvent(eventName, data);
    }
    constructor(HTMLElement){
        this.type = "Youtube";
        this.HTMLElement = HTMLElement;
        this.events = new (0, $5a22d87987052892$export$2e2bcd8739ae039)(this);
        this.player = null;
        // private state
        this.__started = null;
        this.__progress = 0;
    }
}
var $15607a07c80ee7b5$export$2e2bcd8739ae039 = $15607a07c80ee7b5$export$2881499e37b75b9a;



/*! @vimeo/player v2.21.0 | (c) 2024 Vimeo | MIT License | https://github.com/vimeo/player.js */ function $a94b7aed81690016$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a94b7aed81690016$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a94b7aed81690016$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a94b7aed81690016$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a94b7aed81690016$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a94b7aed81690016$var$_regeneratorRuntime() {
    $a94b7aed81690016$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self1, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self1, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self1, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self1, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self1, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self1, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $a94b7aed81690016$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $a94b7aed81690016$var$_asyncToGenerator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                $a94b7aed81690016$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $a94b7aed81690016$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $a94b7aed81690016$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a94b7aed81690016$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a94b7aed81690016$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a94b7aed81690016$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a94b7aed81690016$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a94b7aed81690016$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a94b7aed81690016$var$_defineProperty(obj, key, value) {
    key = $a94b7aed81690016$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a94b7aed81690016$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a94b7aed81690016$var$_setPrototypeOf(subClass, superClass);
}
function $a94b7aed81690016$var$_getPrototypeOf(o) {
    $a94b7aed81690016$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a94b7aed81690016$var$_getPrototypeOf(o);
}
function $a94b7aed81690016$var$_setPrototypeOf(o, p) {
    $a94b7aed81690016$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a94b7aed81690016$var$_setPrototypeOf(o, p);
}
function $a94b7aed81690016$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a94b7aed81690016$var$_construct(Parent, args, Class) {
    if ($a94b7aed81690016$var$_isNativeReflectConstruct()) $a94b7aed81690016$var$_construct = Reflect.construct.bind();
    else $a94b7aed81690016$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $a94b7aed81690016$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $a94b7aed81690016$var$_construct.apply(null, arguments);
}
function $a94b7aed81690016$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $a94b7aed81690016$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $a94b7aed81690016$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$a94b7aed81690016$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $a94b7aed81690016$var$_construct(Class, arguments, $a94b7aed81690016$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $a94b7aed81690016$var$_setPrototypeOf(Wrapper, Class);
    };
    return $a94b7aed81690016$var$_wrapNativeSuper(Class);
}
function $a94b7aed81690016$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $a94b7aed81690016$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a94b7aed81690016$var$_assertThisInitialized(self1);
}
function $a94b7aed81690016$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a94b7aed81690016$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a94b7aed81690016$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a94b7aed81690016$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a94b7aed81690016$var$_possibleConstructorReturn(this, result);
    };
}
function $a94b7aed81690016$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $a94b7aed81690016$var$_toPropertyKey(arg) {
    var key = $a94b7aed81690016$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
/**
 * @module lib/functions
 */ /**
 * Check to see this is a node environment.
 * @type {Boolean}
 */ /* global global */ var $a94b7aed81690016$var$isNode = typeof $parcel$global !== "undefined" && ({}).toString.call($parcel$global) === "[object global]";
/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */ function $a94b7aed81690016$var$getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) return prop;
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}
/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */ function $a94b7aed81690016$var$isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && "nodeName" in element && element.ownerDocument && element.ownerDocument.defaultView);
}
/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */ function $a94b7aed81690016$var$isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}
/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $a94b7aed81690016$var$isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
}
/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */ function $a94b7aed81690016$var$isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
    return expr.test(url);
}
/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */ function $a94b7aed81690016$var$getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
    if ($a94b7aed81690016$var$isInteger(idOrUrl)) return "https://vimeo.com/".concat(idOrUrl);
    if ($a94b7aed81690016$var$isVimeoUrl(idOrUrl)) return idOrUrl.replace("http:", "https:");
    if (id) throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}
/* eslint-disable max-params */ /**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */ var $a94b7aed81690016$var$subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "addEventListener";
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "removeEventListener";
    var eventNames = typeof eventName === "string" ? [
        eventName
    ] : eventName;
    eventNames.forEach(function(evName) {
        target[onName](evName, callback);
    });
    return {
        cancel: function cancel() {
            return eventNames.forEach(function(evName) {
                return target[offName](evName, callback);
            });
        }
    };
};
var $a94b7aed81690016$var$arrayIndexOfSupport = typeof Array.prototype.indexOf !== "undefined";
var $a94b7aed81690016$var$postMessageSupport = typeof window !== "undefined" && typeof window.postMessage !== "undefined";
if (!$a94b7aed81690016$var$isNode && (!$a94b7aed81690016$var$arrayIndexOfSupport || !$a94b7aed81690016$var$postMessageSupport)) throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var $a94b7aed81690016$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $a94b7aed81690016$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */ (function(self1) {
    if (self1.WeakMap) return;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function() {
        try {
            // Avoid IE8's broken Object.defineProperty
            return Object.defineProperty({}, "x", {
                value: 1
            }).x === 1;
        } catch (e) {}
    }();
    var defineProperty = function(object, name, value) {
        if (hasDefine) Object.defineProperty(object, name, {
            configurable: true,
            writable: true,
            value: value
        });
        else object[name] = value;
    };
    self1.WeakMap = function() {
        // ECMA-262 23.3 WeakMap Objects
        function WeakMap1() {
            if (this === void 0) throw new TypeError("Constructor WeakMap requires 'new'");
            defineProperty(this, "_id", genId("_WeakMap"));
            // ECMA-262 23.3.1.1 WeakMap([iterable])
            if (arguments.length > 0) // Currently, WeakMap `iterable` argument is not supported
            throw new TypeError("WeakMap iterable is not supported");
        }
        // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
        defineProperty(WeakMap1.prototype, "delete", function(key) {
            checkInstance(this, "delete");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                delete key[this._id];
                return true;
            }
            return false;
        });
        // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
        defineProperty(WeakMap1.prototype, "get", function(key) {
            checkInstance(this, "get");
            if (!isObject(key)) return void 0;
            var entry = key[this._id];
            if (entry && entry[0] === key) return entry[1];
            return void 0;
        });
        // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
        defineProperty(WeakMap1.prototype, "has", function(key) {
            checkInstance(this, "has");
            if (!isObject(key)) return false;
            var entry = key[this._id];
            if (entry && entry[0] === key) return true;
            return false;
        });
        // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
        defineProperty(WeakMap1.prototype, "set", function(key, value) {
            checkInstance(this, "set");
            if (!isObject(key)) throw new TypeError("Invalid value used as weak map key");
            var entry = key[this._id];
            if (entry && entry[0] === key) {
                entry[1] = value;
                return this;
            }
            defineProperty(key, this._id, [
                key,
                value
            ]);
            return this;
        });
        function checkInstance(x, methodName) {
            if (!isObject(x) || !hasOwnProperty.call(x, "_id")) throw new TypeError(methodName + " method called on incompatible receiver " + typeof x);
        }
        function genId(prefix) {
            return prefix + "_" + rand() + "." + rand();
        }
        function rand() {
            return Math.random().toString().substring(2);
        }
        defineProperty(WeakMap1, "_polyfill", true);
        return WeakMap1;
    }();
    function isObject(x) {
        return Object(x) === x;
    }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $a94b7aed81690016$var$commonjsGlobal !== "undefined" ? $a94b7aed81690016$var$commonjsGlobal : $a94b7aed81690016$var$commonjsGlobal);
var $a94b7aed81690016$var$npo_src = $a94b7aed81690016$var$createCommonjsModule(function(module) {
    /*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/ (function UMD(name, context, definition) {
        // special form of UMD for polyfilling across evironments
        context[name] = context[name] || definition();
        if (module.exports) module.exports = context[name];
    })("Promise", typeof $a94b7aed81690016$var$commonjsGlobal != "undefined" ? $a94b7aed81690016$var$commonjsGlobal : $a94b7aed81690016$var$commonjsGlobal, function DEF() {
        var builtInProp, cycle, scheduling_queue, ToString = Object.prototype.toString, timer = typeof setImmediate != "undefined" ? function timer(fn) {
            return setImmediate(fn);
        } : setTimeout;
        // dammit, IE8.
        try {
            Object.defineProperty({}, "x", {});
            builtInProp = function builtInProp(obj, name, val, config) {
                return Object.defineProperty(obj, name, {
                    value: val,
                    writable: true,
                    configurable: config !== false
                });
            };
        } catch (err) {
            builtInProp = function builtInProp(obj, name, val) {
                obj[name] = val;
                return obj;
            };
        }
        // Note: using a queue instead of array for efficiency
        scheduling_queue = function Queue() {
            var first, last, item;
            function Item(fn, self1) {
                this.fn = fn;
                this.self = self1;
                this.next = void 0;
            }
            return {
                add: function add(fn, self1) {
                    item = new Item(fn, self1);
                    if (last) last.next = item;
                    else first = item;
                    last = item;
                    item = void 0;
                },
                drain: function drain() {
                    var f = first;
                    first = last = cycle = void 0;
                    while(f){
                        f.fn.call(f.self);
                        f = f.next;
                    }
                }
            };
        }();
        function schedule(fn, self1) {
            scheduling_queue.add(fn, self1);
            if (!cycle) cycle = timer(scheduling_queue.drain);
        }
        // promise duck typing
        function isThenable(o) {
            var _then, o_type = typeof o;
            if (o != null && (o_type == "object" || o_type == "function")) _then = o.then;
            return typeof _then == "function" ? _then : false;
        }
        function notify() {
            for(var i = 0; i < this.chain.length; i++)notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
            this.chain.length = 0;
        }
        // NOTE: This is a separate function to isolate
        // the `try..catch` so that other code can be
        // optimized better
        function notifyIsolated(self1, cb, chain) {
            var ret, _then;
            try {
                if (cb === false) chain.reject(self1.msg);
                else {
                    if (cb === true) ret = self1.msg;
                    else ret = cb.call(void 0, self1.msg);
                    if (ret === chain.promise) chain.reject(TypeError("Promise-chain cycle"));
                    else if (_then = isThenable(ret)) _then.call(ret, chain.resolve, chain.reject);
                    else chain.resolve(ret);
                }
            } catch (err) {
                chain.reject(err);
            }
        }
        function resolve(msg) {
            var _then, self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            try {
                if (_then = isThenable(msg)) schedule(function() {
                    var def_wrapper = new MakeDefWrapper(self1);
                    try {
                        _then.call(msg, function $resolve$() {
                            resolve.apply(def_wrapper, arguments);
                        }, function $reject$() {
                            reject.apply(def_wrapper, arguments);
                        });
                    } catch (err) {
                        reject.call(def_wrapper, err);
                    }
                });
                else {
                    self1.msg = msg;
                    self1.state = 1;
                    if (self1.chain.length > 0) schedule(notify, self1);
                }
            } catch (err) {
                reject.call(new MakeDefWrapper(self1), err);
            }
        }
        function reject(msg) {
            var self1 = this;
            // already triggered?
            if (self1.triggered) return;
            self1.triggered = true;
            // unwrap
            if (self1.def) self1 = self1.def;
            self1.msg = msg;
            self1.state = 2;
            if (self1.chain.length > 0) schedule(notify, self1);
        }
        function iteratePromises(Constructor, arr, resolver, rejecter) {
            for(var idx = 0; idx < arr.length; idx++)(function IIFE(idx) {
                Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
                    resolver(idx, msg);
                }, rejecter);
            })(idx);
        }
        function MakeDefWrapper(self1) {
            this.def = self1;
            this.triggered = false;
        }
        function MakeDef(self1) {
            this.promise = self1;
            this.state = 0;
            this.triggered = false;
            this.chain = [];
            this.msg = void 0;
        }
        function Promise1(executor) {
            if (typeof executor != "function") throw TypeError("Not a function");
            if (this.__NPO__ !== 0) throw TypeError("Not a promise");
            // instance shadowing the inherited "brand"
            // to signal an already "initialized" promise
            this.__NPO__ = 1;
            var def = new MakeDef(this);
            this["then"] = function then(success, failure) {
                var o = {
                    success: typeof success == "function" ? success : true,
                    failure: typeof failure == "function" ? failure : false
                };
                // Note: `then(..)` itself can be borrowed to be used against
                // a different promise constructor for making the chained promise,
                // by substituting a different `this` binding.
                o.promise = new this.constructor(function extractChain(resolve, reject) {
                    if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                    o.resolve = resolve;
                    o.reject = reject;
                });
                def.chain.push(o);
                if (def.state !== 0) schedule(notify, def);
                return o.promise;
            };
            this["catch"] = function $catch$(failure) {
                return this.then(void 0, failure);
            };
            try {
                executor.call(void 0, function publicResolve(msg) {
                    resolve.call(def, msg);
                }, function publicReject(msg) {
                    reject.call(def, msg);
                });
            } catch (err) {
                reject.call(def, err);
            }
        }
        var PromisePrototype = builtInProp({}, "constructor", Promise1, /*configurable=*/ false);
        // Note: Android 4 cannot use `Object.defineProperty(..)` here
        Promise1.prototype = PromisePrototype;
        // built-in "brand" to signal an "uninitialized" promise
        builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/ false);
        builtInProp(Promise1, "resolve", function Promise$resolve(msg) {
            var Constructor = this;
            // spec mandated checks
            // note: best "isPromise" check that's practical for now
            if (msg && typeof msg == "object" && msg.__NPO__ === 1) return msg;
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                resolve(msg);
            });
        });
        builtInProp(Promise1, "reject", function Promise$reject(msg) {
            return new this(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                reject(msg);
            });
        });
        builtInProp(Promise1, "all", function Promise$all(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            if (arr.length === 0) return Constructor.resolve([]);
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                var len = arr.length, msgs = Array(len), count = 0;
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    msgs[idx] = msg;
                    if (++count === len) resolve(msgs);
                }, reject);
            });
        });
        builtInProp(Promise1, "race", function Promise$race(arr) {
            var Constructor = this;
            // spec mandated checks
            if (ToString.call(arr) != "[object Array]") return Constructor.reject(TypeError("Not an array"));
            return new Constructor(function executor(resolve, reject) {
                if (typeof resolve != "function" || typeof reject != "function") throw TypeError("Not a function");
                iteratePromises(Constructor, arr, function resolver(idx, msg) {
                    resolve(msg);
                }, reject);
            });
        });
        return Promise1;
    });
});
/**
 * @module lib/callbacks
 */ var $a94b7aed81690016$var$callbackMap = new WeakMap();
/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */ function $a94b7aed81690016$var$storeCallback(player, name, callback) {
    var playerCallbacks = $a94b7aed81690016$var$callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) playerCallbacks[name] = [];
    playerCallbacks[name].push(callback);
    $a94b7aed81690016$var$callbackMap.set(player.element, playerCallbacks);
}
/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */ function $a94b7aed81690016$var$getCallbacks(player, name) {
    var playerCallbacks = $a94b7aed81690016$var$callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
}
/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */ function $a94b7aed81690016$var$removeCallback(player, name, callback) {
    var playerCallbacks = $a94b7aed81690016$var$callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) return true;
    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
        playerCallbacks[name] = [];
        $a94b7aed81690016$var$callbackMap.set(player.element, playerCallbacks);
        return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) playerCallbacks[name].splice(index, 1);
    $a94b7aed81690016$var$callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
}
/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */ function $a94b7aed81690016$var$shiftCallbacks(player, name) {
    var playerCallbacks = $a94b7aed81690016$var$getCallbacks(player, name);
    if (playerCallbacks.length < 1) return false;
    var callback = playerCallbacks.shift();
    $a94b7aed81690016$var$removeCallback(player, name, callback);
    return callback;
}
/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */ function $a94b7aed81690016$var$swapCallbacks(oldElement, newElement) {
    var playerCallbacks = $a94b7aed81690016$var$callbackMap.get(oldElement);
    $a94b7aed81690016$var$callbackMap.set(newElement, playerCallbacks);
    $a94b7aed81690016$var$callbackMap.delete(oldElement);
}
/**
 * @module lib/postmessage
 */ /**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */ function $a94b7aed81690016$var$parseMessageData(data) {
    if (typeof data === "string") try {
        data = JSON.parse(data);
    } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
    }
    return data;
}
/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {object} params The parameters to send to the player.
 * @return {void}
 */ function $a94b7aed81690016$var$postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) return;
    var message = {
        method: method
    };
    if (params !== undefined) message.value = params;
    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    if (ieVersion >= 8 && ieVersion < 10) message = JSON.stringify(message);
    player.element.contentWindow.postMessage(message, player.origin);
}
/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */ function $a94b7aed81690016$var$processData(player, data) {
    data = $a94b7aed81690016$var$parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
        if (data.event === "error") {
            var promises = $a94b7aed81690016$var$getCallbacks(player, data.data.method);
            promises.forEach(function(promise) {
                var error = new Error(data.data.message);
                error.name = data.data.name;
                promise.reject(error);
                $a94b7aed81690016$var$removeCallback(player, data.data.method, promise);
            });
        }
        callbacks = $a94b7aed81690016$var$getCallbacks(player, "event:".concat(data.event));
        param = data.data;
    } else if (data.method) {
        var callback = $a94b7aed81690016$var$shiftCallbacks(player, data.method);
        if (callback) {
            callbacks.push(callback);
            param = data.value;
        }
    }
    callbacks.forEach(function(callback) {
        try {
            if (typeof callback === "function") {
                callback.call(player, param);
                return;
            }
            callback.resolve(param);
        } catch (e) {
        // empty
        }
    });
}
/**
 * @module lib/embed
 */ var $a94b7aed81690016$var$oEmbedParameters = [
    "airplay",
    "audio_tracks",
    "autopause",
    "autoplay",
    "background",
    "byline",
    "cc",
    "chapters",
    "chromecast",
    "color",
    "colors",
    "controls",
    "dnt",
    "fullscreen",
    "height",
    "id",
    "interactive_params",
    "keyboard",
    "loop",
    "maxheight",
    "maxwidth",
    "muted",
    "play_button_position",
    "playsinline",
    "portrait",
    "progress_bar",
    "quality_selector",
    "responsive",
    "speed",
    "texttrack",
    "title",
    "transcript",
    "transparent",
    "url",
    "vimeo_logo",
    "volume",
    "width"
];
/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */ function $a94b7aed81690016$var$getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $a94b7aed81690016$var$oEmbedParameters.reduce(function(params, param) {
        var value = element.getAttribute("data-vimeo-".concat(param));
        if (value || value === "") params[param] = value === "" ? 1 : value;
        return params;
    }, defaults);
}
/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */ function $a94b7aed81690016$var$createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) throw new TypeError("An element must be provided");
    if (element.getAttribute("data-vimeo-initialized") !== null) return element.querySelector("iframe");
    var div = document.createElement("div");
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute("data-vimeo-initialized", "true");
    return element.querySelector("iframe");
}
/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */ function $a94b7aed81690016$var$getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function(resolve, reject) {
        if (!$a94b7aed81690016$var$isVimeoUrl(videoUrl)) throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
        var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
        for(var param in params)if (params.hasOwnProperty(param)) url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        var xhr = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function() {
            if (xhr.status === 404) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
                return;
            }
            if (xhr.status === 403) {
                reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                return;
            }
            try {
                var json = JSON.parse(xhr.responseText);
                // Check api response for 403 on oembed
                if (json.domain_status_code === 403) {
                    // We still want to create the embed to give users visual feedback
                    $a94b7aed81690016$var$createEmbed(json, element);
                    reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
                    return;
                }
                resolve(json);
            } catch (error) {
                reject(error);
            }
        };
        xhr.onerror = function() {
            var status = xhr.status ? " (".concat(xhr.status, ")") : "";
            reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
        };
        xhr.send();
    });
}
/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $a94b7aed81690016$var$initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll("[data-vimeo-id], [data-vimeo-url]"));
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error creating an embed: ".concat(error));
    };
    elements.forEach(function(element) {
        try {
            // Skip any that have data-vimeo-defer
            if (element.getAttribute("data-vimeo-defer") !== null) return;
            var params = $a94b7aed81690016$var$getOEmbedParameters(element);
            var url = $a94b7aed81690016$var$getVimeoUrl(params);
            $a94b7aed81690016$var$getOEmbedData(url, params, element).then(function(data) {
                return $a94b7aed81690016$var$createEmbed(data, element);
            }).catch(handleError);
        } catch (error) {
            handleError(error);
        }
    });
}
/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $a94b7aed81690016$var$resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) return;
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
        if (!$a94b7aed81690016$var$isVimeoUrl(event.origin)) return;
        // 'spacechange' is fired only on embeds with cards
        if (!event.data || event.data.event !== "spacechange") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            if (iframes[i].contentWindow !== event.source) continue;
            // Change padding-bottom of the enclosing div to accommodate
            // card carousel without distorting aspect ratio
            var space = iframes[i].parentElement;
            space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
            break;
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $a94b7aed81690016$var$initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) return;
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
        if (!$a94b7aed81690016$var$isVimeoUrl(event.origin)) return;
        var data = $a94b7aed81690016$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        for(var i = 0; i < iframes.length; i++){
            var iframe = iframes[i];
            // Initiate appendVideoMetadata if iframe is a Vimeo embed
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($a94b7aed81690016$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $a94b7aed81690016$var$Player(iframe);
                player.callMethod("appendVideoMetadata", window.location.href);
            }
        }
    };
    window.addEventListener("message", onMessage);
}
/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */ function $a94b7aed81690016$var$checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) return;
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
        if ("console" in window && console.error) console.error("There was an error getting video Id: ".concat(error));
    };
    var onMessage = function onMessage(event) {
        if (!$a94b7aed81690016$var$isVimeoUrl(event.origin)) return;
        var data = $a94b7aed81690016$var$parseMessageData(event.data);
        if (!data || data.event !== "ready") return;
        var iframes = parent.querySelectorAll("iframe");
        var _loop = function _loop() {
            var iframe = iframes[i];
            var isValidMessageSource = iframe.contentWindow === event.source;
            if ($a94b7aed81690016$var$isVimeoEmbed(iframe.src) && isValidMessageSource) {
                var player = new $a94b7aed81690016$var$Player(iframe);
                player.getVideoId().then(function(videoId) {
                    var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
                    if (matches && matches[1]) {
                        var sec = decodeURI(matches[1]);
                        player.setCurrentTime(sec);
                    }
                    return;
                }).catch(handleError);
            }
        };
        for(var i = 0; i < iframes.length; i++)_loop();
    };
    window.addEventListener("message", onMessage);
}
/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */ function $a94b7aed81690016$var$initializeScreenfull() {
    var fn = function() {
        var val;
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            // New WebKit
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            // Old WebKit
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        fullscreenchange: fn.fullscreenchange,
        fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
        request: function request(element) {
            return new Promise(function(resolve, reject) {
                var onFullScreenEntered = function onFullScreenEntered() {
                    screenfull.off("fullscreenchange", onFullScreenEntered);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            });
        },
        exit: function exit() {
            return new Promise(function(resolve, reject) {
                if (!screenfull.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = function onFullScreenExit() {
                    screenfull.off("fullscreenchange", onFullScreenExit);
                    resolve();
                };
                screenfull.on("fullscreenchange", onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            });
        },
        on: function on(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback);
        },
        off: function off(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback);
        }
    };
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function get() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function get() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function get() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    return screenfull;
}
/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */ /** @typedef {import('./timing-object.types').TimingObject} TimingObject */ /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */ /** @typedef {(msg: string) => any} Logger */ /** @typedef {import('timing-object.types').TConnectionState} TConnectionState */ /**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */ var $a94b7aed81690016$var$defaultOptions = {
    role: "viewer",
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
};
/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */ var $a94b7aed81690016$var$TimingSrcConnector = /*#__PURE__*/ function(_EventTarget) {
    $a94b7aed81690016$var$_inherits(TimingSrcConnector, _EventTarget);
    var _super = $a94b7aed81690016$var$_createSuper(TimingSrcConnector);
    /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */ function TimingSrcConnector(_player, timingObject) {
        var _this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var logger = arguments.length > 3 ? arguments[3] : undefined;
        $a94b7aed81690016$var$_classCallCheck(this, TimingSrcConnector);
        _this = _super.call(this);
        $a94b7aed81690016$var$_defineProperty($a94b7aed81690016$var$_assertThisInitialized(_this), "logger", void 0);
        $a94b7aed81690016$var$_defineProperty($a94b7aed81690016$var$_assertThisInitialized(_this), "speedAdjustment", 0);
        /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */ $a94b7aed81690016$var$_defineProperty($a94b7aed81690016$var$_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/ function() {
            var _ref = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
                var newPlaybackRate;
                return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!(_this.speedAdjustment === newAdjustment)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            _context.next = 4;
                            return player.getPlaybackRate();
                        case 4:
                            _context.t0 = _context.sent;
                            _context.t1 = _this.speedAdjustment;
                            _context.t2 = _context.t0 - _context.t1;
                            _context.t3 = newAdjustment;
                            newPlaybackRate = _context.t2 + _context.t3;
                            _this.log("New playbackRate:  ".concat(newPlaybackRate));
                            _context.next = 12;
                            return player.setPlaybackRate(newPlaybackRate);
                        case 12:
                            _this.speedAdjustment = newAdjustment;
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.logger = logger;
        _this.init(timingObject, _player, $a94b7aed81690016$var$_objectSpread2($a94b7aed81690016$var$_objectSpread2({}, $a94b7aed81690016$var$defaultOptions), options));
        return _this;
    }
    $a94b7aed81690016$var$_createClass(TimingSrcConnector, [
        {
            key: "disconnect",
            value: function disconnect() {
                this.dispatchEvent(new Event("disconnect"));
            }
        },
        {
            key: "init",
            value: function() {
                var _init = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
                    var _this2 = this;
                    var playerUpdater, positionSync, timingObjectUpdater;
                    return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.waitForTOReadyState(timingObject, "open");
                            case 2:
                                if (!(options.role === "viewer")) {
                                    _context2.next = 10;
                                    break;
                                }
                                _context2.next = 5;
                                return this.updatePlayer(timingObject, player, options);
                            case 5:
                                playerUpdater = $a94b7aed81690016$var$subscribe(timingObject, "change", function() {
                                    return _this2.updatePlayer(timingObject, player, options);
                                });
                                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                                this.addEventListener("disconnect", function() {
                                    positionSync.cancel();
                                    playerUpdater.cancel();
                                });
                                _context2.next = 14;
                                break;
                            case 10:
                                _context2.next = 12;
                                return this.updateTimingObject(timingObject, player);
                            case 12:
                                timingObjectUpdater = $a94b7aed81690016$var$subscribe(player, [
                                    "seeked",
                                    "play",
                                    "pause",
                                    "ratechange"
                                ], function() {
                                    return _this2.updateTimingObject(timingObject, player);
                                }, "on", "off");
                                this.addEventListener("disconnect", function() {
                                    return timingObjectUpdater.cancel();
                                });
                            case 14:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function init(_x3, _x4, _x5) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "updateTimingObject",
            value: function() {
                var _updateTimingObject = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee3(timingObject, player) {
                    return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.t0 = timingObject;
                                _context3.next = 3;
                                return player.getCurrentTime();
                            case 3:
                                _context3.t1 = _context3.sent;
                                _context3.next = 6;
                                return player.getPaused();
                            case 6:
                                if (!_context3.sent) {
                                    _context3.next = 10;
                                    break;
                                }
                                _context3.t2 = 0;
                                _context3.next = 13;
                                break;
                            case 10:
                                _context3.next = 12;
                                return player.getPlaybackRate();
                            case 12:
                                _context3.t2 = _context3.sent;
                            case 13:
                                _context3.t3 = _context3.t2;
                                _context3.t4 = {
                                    position: _context3.t1,
                                    velocity: _context3.t3
                                };
                                _context3.t0.update.call(_context3.t0, _context3.t4);
                            case 16:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function updateTimingObject(_x6, _x7) {
                    return _updateTimingObject.apply(this, arguments);
                }
                return updateTimingObject;
            }()
        },
        {
            key: "updatePlayer",
            value: function() {
                var _updatePlayer = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
                    var _timingObject$query, position, velocity;
                    return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                                if (typeof position === "number") player.setCurrentTime(position);
                                if (!(typeof velocity === "number")) {
                                    _context5.next = 25;
                                    break;
                                }
                                if (!(velocity === 0)) {
                                    _context5.next = 11;
                                    break;
                                }
                                _context5.next = 6;
                                return player.getPaused();
                            case 6:
                                _context5.t0 = _context5.sent;
                                if (!(_context5.t0 === false)) {
                                    _context5.next = 9;
                                    break;
                                }
                                player.pause();
                            case 9:
                                _context5.next = 25;
                                break;
                            case 11:
                                if (!(velocity > 0)) {
                                    _context5.next = 25;
                                    break;
                                }
                                _context5.next = 14;
                                return player.getPaused();
                            case 14:
                                _context5.t1 = _context5.sent;
                                if (!(_context5.t1 === true)) {
                                    _context5.next = 19;
                                    break;
                                }
                                _context5.next = 18;
                                return player.play().catch(/*#__PURE__*/ function() {
                                    var _ref2 = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee4(err) {
                                        return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                                            while(true)switch(_context4.prev = _context4.next){
                                                case 0:
                                                    if (!(err.name === "NotAllowedError" && options.autoPlayMuted)) {
                                                        _context4.next = 5;
                                                        break;
                                                    }
                                                    _context4.next = 3;
                                                    return player.setMuted(true);
                                                case 3:
                                                    _context4.next = 5;
                                                    return player.play().catch(function(err2) {
                                                        return console.error("Couldn't play the video from TimingSrcConnector. Error:", err2);
                                                    });
                                                case 5:
                                                case "end":
                                                    return _context4.stop();
                                            }
                                        }, _callee4);
                                    }));
                                    return function(_x11) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }());
                            case 18:
                                this.updatePlayer(timingObject, player, options);
                            case 19:
                                _context5.next = 21;
                                return player.getPlaybackRate();
                            case 21:
                                _context5.t2 = _context5.sent;
                                _context5.t3 = velocity;
                                if (!(_context5.t2 !== _context5.t3)) {
                                    _context5.next = 25;
                                    break;
                                }
                                player.setPlaybackRate(velocity);
                            case 25:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updatePlayer(_x8, _x9, _x10) {
                    return _updatePlayer.apply(this, arguments);
                }
                return updatePlayer;
            }()
        },
        {
            key: "maintainPlaybackPosition",
            value: function maintainPlaybackPosition(timingObject, player, options) {
                var _this3 = this;
                var allowedDrift = options.allowedDrift, maxAllowedDrift = options.maxAllowedDrift, minCheckInterval = options.minCheckInterval, maxRateAdjustment = options.maxRateAdjustment, maxTimeToCatchUp = options.maxTimeToCatchUp;
                var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
                var check = /*#__PURE__*/ function() {
                    var _ref3 = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee6() {
                        var diff, diffAbs, min, max, adjustment;
                        return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                            while(true)switch(_context6.prev = _context6.next){
                                case 0:
                                    _context6.t0 = timingObject.query().velocity === 0;
                                    if (_context6.t0) {
                                        _context6.next = 6;
                                        break;
                                    }
                                    _context6.next = 4;
                                    return player.getPaused();
                                case 4:
                                    _context6.t1 = _context6.sent;
                                    _context6.t0 = _context6.t1 === true;
                                case 6:
                                    if (!_context6.t0) {
                                        _context6.next = 8;
                                        break;
                                    }
                                    return _context6.abrupt("return");
                                case 8:
                                    _context6.t2 = timingObject.query().position;
                                    _context6.next = 11;
                                    return player.getCurrentTime();
                                case 11:
                                    _context6.t3 = _context6.sent;
                                    diff = _context6.t2 - _context6.t3;
                                    diffAbs = Math.abs(diff);
                                    _this3.log("Drift: ".concat(diff));
                                    if (!(diffAbs > maxAllowedDrift)) {
                                        _context6.next = 22;
                                        break;
                                    }
                                    _context6.next = 18;
                                    return _this3.adjustSpeed(player, 0);
                                case 18:
                                    player.setCurrentTime(timingObject.query().position);
                                    _this3.log("Resync by currentTime");
                                    _context6.next = 29;
                                    break;
                                case 22:
                                    if (!(diffAbs > allowedDrift)) {
                                        _context6.next = 29;
                                        break;
                                    }
                                    min = diffAbs / maxTimeToCatchUp;
                                    max = maxRateAdjustment;
                                    adjustment = min < max ? (max - min) / 2 : max;
                                    _context6.next = 28;
                                    return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                                case 28:
                                    _this3.log("Resync by playbackRate");
                                case 29:
                                case "end":
                                    return _context6.stop();
                            }
                        }, _callee6);
                    }));
                    return function check() {
                        return _ref3.apply(this, arguments);
                    };
                }();
                var interval = setInterval(function() {
                    return check();
                }, syncInterval);
                return {
                    cancel: function cancel() {
                        return clearInterval(interval);
                    }
                };
            }
        },
        {
            key: "log",
            value: function log(msg) {
                var _this$logger;
                (_this$logger = this.logger) === null || _this$logger === void 0 || _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
            }
        },
        {
            key: "waitForTOReadyState",
            value: /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */ function waitForTOReadyState(timingObject, state) {
                return new Promise(function(resolve) {
                    var check = function check() {
                        if (timingObject.readyState === state) resolve();
                        else timingObject.addEventListener("readystatechange", check, {
                            once: true
                        });
                    };
                    check();
                });
            }
        }
    ]);
    return TimingSrcConnector;
}(/*#__PURE__*/ $a94b7aed81690016$var$_wrapNativeSuper(EventTarget));
var $a94b7aed81690016$var$playerMap = new WeakMap();
var $a94b7aed81690016$var$readyMap = new WeakMap();
var $a94b7aed81690016$var$screenfull = {};
var $a94b7aed81690016$var$Player = /*#__PURE__*/ function() {
    /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */ function Player(element) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $a94b7aed81690016$var$_classCallCheck(this, Player);
        /* global jQuery */ if (window.jQuery && element instanceof jQuery) {
            if (element.length > 1 && window.console && console.warn) console.warn("A jQuery object with multiple elements was passed, using the first element.");
            element = element[0];
        }
        // Find an element by ID
        if (typeof document !== "undefined" && typeof element === "string") element = document.getElementById(element);
        // Not an element!
        if (!$a94b7aed81690016$var$isDomElement(element)) throw new TypeError("You must pass either a valid element or a valid id.");
        // Already initialized an embed in this div, so grab the iframe
        if (element.nodeName !== "IFRAME") {
            var iframe = element.querySelector("iframe");
            if (iframe) element = iframe;
        }
        // iframe url is not a Vimeo url
        if (element.nodeName === "IFRAME" && !$a94b7aed81690016$var$isVimeoUrl(element.getAttribute("src") || "")) throw new Error("The player element passed isn\u2019t a Vimeo embed.");
        // If there is already a player object in the map, return that
        if ($a94b7aed81690016$var$playerMap.has(element)) return $a94b7aed81690016$var$playerMap.get(element);
        this._window = element.ownerDocument.defaultView;
        this.element = element;
        this.origin = "*";
        var readyPromise = new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
            _this._onMessage = function(event) {
                if (!$a94b7aed81690016$var$isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) return;
                if (_this.origin === "*") _this.origin = event.origin;
                var data = $a94b7aed81690016$var$parseMessageData(event.data);
                var isError = data && data.event === "error";
                var isReadyError = isError && data.data && data.data.method === "ready";
                if (isReadyError) {
                    var error = new Error(data.data.message);
                    error.name = data.data.name;
                    reject(error);
                    return;
                }
                var isReadyEvent = data && data.event === "ready";
                var isPingResponse = data && data.method === "ping";
                if (isReadyEvent || isPingResponse) {
                    _this.element.setAttribute("data-ready", "true");
                    resolve();
                    return;
                }
                $a94b7aed81690016$var$processData(_this, data);
            };
            _this._window.addEventListener("message", _this._onMessage);
            if (_this.element.nodeName !== "IFRAME") {
                var params = $a94b7aed81690016$var$getOEmbedParameters(element, options);
                var url = $a94b7aed81690016$var$getVimeoUrl(params);
                $a94b7aed81690016$var$getOEmbedData(url, params, element).then(function(data) {
                    var iframe = $a94b7aed81690016$var$createEmbed(data, element);
                    // Overwrite element with the new iframe,
                    // but store reference to the original element
                    _this.element = iframe;
                    _this._originalElement = element;
                    $a94b7aed81690016$var$swapCallbacks(element, iframe);
                    $a94b7aed81690016$var$playerMap.set(_this.element, _this);
                    return data;
                }).catch(reject);
            }
        });
        // Store a copy of this Player in the map
        $a94b7aed81690016$var$readyMap.set(this, readyPromise);
        $a94b7aed81690016$var$playerMap.set(this.element, this);
        // Send a ping to the iframe so the ready promise will be resolved if
        // the player is already ready.
        if (this.element.nodeName === "IFRAME") $a94b7aed81690016$var$postMessage(this, "ping");
        if ($a94b7aed81690016$var$screenfull.isEnabled) {
            var exitFullscreen = function exitFullscreen() {
                return $a94b7aed81690016$var$screenfull.exit();
            };
            this.fullscreenchangeHandler = function() {
                if ($a94b7aed81690016$var$screenfull.isFullscreen) $a94b7aed81690016$var$storeCallback(_this, "event:exitFullscreen", exitFullscreen);
                else $a94b7aed81690016$var$removeCallback(_this, "event:exitFullscreen", exitFullscreen);
                // eslint-disable-next-line
                _this.ready().then(function() {
                    $a94b7aed81690016$var$postMessage(_this, "fullscreenchange", $a94b7aed81690016$var$screenfull.isFullscreen);
                });
            };
            $a94b7aed81690016$var$screenfull.on("fullscreenchange", this.fullscreenchangeHandler);
        }
        return this;
    }
    /**
   * Get a promise for a method.
   *
   * @param {string} name The API method to call.
   * @param {Object} [args={}] Arguments to send via postMessage.
   * @return {Promise}
   */ $a94b7aed81690016$var$_createClass(Player, [
        {
            key: "callMethod",
            value: function callMethod(name) {
                var _this2 = this;
                var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this2.ready().then(function() {
                        $a94b7aed81690016$var$storeCallback(_this2, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $a94b7aed81690016$var$postMessage(_this2, name, args);
                    }).catch(reject);
                });
            }
        },
        {
            key: "get",
            value: function get(name) {
                var _this3 = this;
                return new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
                    name = $a94b7aed81690016$var$getMethodName(name, "get");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this3.ready().then(function() {
                        $a94b7aed81690016$var$storeCallback(_this3, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $a94b7aed81690016$var$postMessage(_this3, name);
                    }).catch(reject);
                });
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                var _this4 = this;
                return new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
                    name = $a94b7aed81690016$var$getMethodName(name, "set");
                    if (value === undefined || value === null) throw new TypeError("There must be a value to set.");
                    // We are storing the resolve/reject handlers to call later, so we
                    // can’t return here.
                    // eslint-disable-next-line promise/always-return
                    return _this4.ready().then(function() {
                        $a94b7aed81690016$var$storeCallback(_this4, name, {
                            resolve: resolve,
                            reject: reject
                        });
                        $a94b7aed81690016$var$postMessage(_this4, name, value);
                    }).catch(reject);
                });
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (!callback) throw new TypeError("You must pass a callback function.");
                if (typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var callbacks = $a94b7aed81690016$var$getCallbacks(this, "event:".concat(eventName));
                if (callbacks.length === 0) this.callMethod("addEventListener", eventName).catch(function() {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
                $a94b7aed81690016$var$storeCallback(this, "event:".concat(eventName), callback);
            }
        },
        {
            key: "off",
            value: function off(eventName, callback) {
                if (!eventName) throw new TypeError("You must pass an event name.");
                if (callback && typeof callback !== "function") throw new TypeError("The callback must be a function.");
                var lastCallback = $a94b7aed81690016$var$removeCallback(this, "event:".concat(eventName), callback);
                // If there are no callbacks left, remove the listener
                if (lastCallback) this.callMethod("removeEventListener", eventName).catch(function(e) {
                // Ignore the error. There will be an error event fired that
                // will trigger the error callback if they are listening.
                });
            }
        },
        {
            key: "loadVideo",
            value: function loadVideo(options) {
                return this.callMethod("loadVideo", options);
            }
        },
        {
            key: "ready",
            value: function ready() {
                var readyPromise = $a94b7aed81690016$var$readyMap.get(this) || new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
                    reject(new Error("Unknown player. Probably unloaded."));
                });
                return $a94b7aed81690016$var$npo_src.resolve(readyPromise);
            }
        },
        {
            key: "addCuePoint",
            value: function addCuePoint(time) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return this.callMethod("addCuePoint", {
                    time: time,
                    data: data
                });
            }
        },
        {
            key: "removeCuePoint",
            value: function removeCuePoint(id) {
                return this.callMethod("removeCuePoint", id);
            }
        },
        {
            key: "enableTextTrack",
            value: function enableTextTrack(language, kind) {
                if (!language) throw new TypeError("You must pass a language.");
                return this.callMethod("enableTextTrack", {
                    language: language,
                    kind: kind
                });
            }
        },
        {
            key: "disableTextTrack",
            value: function disableTextTrack() {
                return this.callMethod("disableTextTrack");
            }
        },
        {
            key: "pause",
            value: function pause() {
                return this.callMethod("pause");
            }
        },
        {
            key: "play",
            value: function play() {
                return this.callMethod("play");
            }
        },
        {
            key: "requestFullscreen",
            value: function requestFullscreen() {
                if ($a94b7aed81690016$var$screenfull.isEnabled) return $a94b7aed81690016$var$screenfull.request(this.element);
                return this.callMethod("requestFullscreen");
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                if ($a94b7aed81690016$var$screenfull.isEnabled) return $a94b7aed81690016$var$screenfull.exit();
                return this.callMethod("exitFullscreen");
            }
        },
        {
            key: "getFullscreen",
            value: function getFullscreen() {
                if ($a94b7aed81690016$var$screenfull.isEnabled) return $a94b7aed81690016$var$npo_src.resolve($a94b7aed81690016$var$screenfull.isFullscreen);
                return this.get("fullscreen");
            }
        },
        {
            key: "requestPictureInPicture",
            value: function requestPictureInPicture() {
                return this.callMethod("requestPictureInPicture");
            }
        },
        {
            key: "exitPictureInPicture",
            value: function exitPictureInPicture() {
                return this.callMethod("exitPictureInPicture");
            }
        },
        {
            key: "getPictureInPicture",
            value: function getPictureInPicture() {
                return this.get("pictureInPicture");
            }
        },
        {
            key: "remotePlaybackPrompt",
            value: function remotePlaybackPrompt() {
                return this.callMethod("remotePlaybackPrompt");
            }
        },
        {
            key: "unload",
            value: function unload() {
                return this.callMethod("unload");
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this5 = this;
                return new $a94b7aed81690016$var$npo_src(function(resolve) {
                    $a94b7aed81690016$var$readyMap.delete(_this5);
                    $a94b7aed81690016$var$playerMap.delete(_this5.element);
                    if (_this5._originalElement) {
                        $a94b7aed81690016$var$playerMap.delete(_this5._originalElement);
                        _this5._originalElement.removeAttribute("data-vimeo-initialized");
                    }
                    if (_this5.element && _this5.element.nodeName === "IFRAME" && _this5.element.parentNode) {
                        // If we've added an additional wrapper div, remove that from the DOM.
                        // If not, just remove the iframe element.
                        if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
                        else _this5.element.parentNode.removeChild(_this5.element);
                    }
                    // If the clip is private there is a case where the element stays the
                    // div element. Destroy should reset the div and remove the iframe child.
                    if (_this5.element && _this5.element.nodeName === "DIV" && _this5.element.parentNode) {
                        _this5.element.removeAttribute("data-vimeo-initialized");
                        var iframe = _this5.element.querySelector("iframe");
                        if (iframe && iframe.parentNode) {
                            // If we've added an additional wrapper div, remove that from the DOM.
                            // If not, just remove the iframe element.
                            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) iframe.parentNode.parentNode.removeChild(iframe.parentNode);
                            else iframe.parentNode.removeChild(iframe);
                        }
                    }
                    _this5._window.removeEventListener("message", _this5._onMessage);
                    if ($a94b7aed81690016$var$screenfull.isEnabled) $a94b7aed81690016$var$screenfull.off("fullscreenchange", _this5.fullscreenchangeHandler);
                    resolve();
                });
            }
        },
        {
            key: "getAutopause",
            value: function getAutopause() {
                return this.get("autopause");
            }
        },
        {
            key: "setAutopause",
            value: function setAutopause(autopause) {
                return this.set("autopause", autopause);
            }
        },
        {
            key: "getBuffered",
            value: function getBuffered() {
                return this.get("buffered");
            }
        },
        {
            key: "getCameraProps",
            value: function getCameraProps() {
                return this.get("cameraProps");
            }
        },
        {
            key: "setCameraProps",
            value: function setCameraProps(camera) {
                return this.set("cameraProps", camera);
            }
        },
        {
            key: "getChapters",
            value: function getChapters() {
                return this.get("chapters");
            }
        },
        {
            key: "getCurrentChapter",
            value: function getCurrentChapter() {
                return this.get("currentChapter");
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return this.get("color");
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return $a94b7aed81690016$var$npo_src.all([
                    this.get("colorOne"),
                    this.get("colorTwo"),
                    this.get("colorThree"),
                    this.get("colorFour")
                ]);
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                return this.set("color", color);
            }
        },
        {
            key: "setColors",
            value: function setColors(colors) {
                if (!Array.isArray(colors)) return new $a94b7aed81690016$var$npo_src(function(resolve, reject) {
                    return reject(new TypeError("Argument must be an array."));
                });
                var nullPromise = new $a94b7aed81690016$var$npo_src(function(resolve) {
                    return resolve(null);
                });
                var colorPromises = [
                    colors[0] ? this.set("colorOne", colors[0]) : nullPromise,
                    colors[1] ? this.set("colorTwo", colors[1]) : nullPromise,
                    colors[2] ? this.set("colorThree", colors[2]) : nullPromise,
                    colors[3] ? this.set("colorFour", colors[3]) : nullPromise
                ];
                return $a94b7aed81690016$var$npo_src.all(colorPromises);
            }
        },
        {
            key: "getCuePoints",
            value: function getCuePoints() {
                return this.get("cuePoints");
            }
        },
        {
            key: "getCurrentTime",
            value: function getCurrentTime() {
                return this.get("currentTime");
            }
        },
        {
            key: "setCurrentTime",
            value: function setCurrentTime(currentTime) {
                return this.set("currentTime", currentTime);
            }
        },
        {
            key: "getDuration",
            value: function getDuration() {
                return this.get("duration");
            }
        },
        {
            key: "getEnded",
            value: function getEnded() {
                return this.get("ended");
            }
        },
        {
            key: "getLoop",
            value: function getLoop() {
                return this.get("loop");
            }
        },
        {
            key: "setLoop",
            value: function setLoop(loop) {
                return this.set("loop", loop);
            }
        },
        {
            key: "setMuted",
            value: function setMuted(muted) {
                return this.set("muted", muted);
            }
        },
        {
            key: "getMuted",
            value: function getMuted() {
                return this.get("muted");
            }
        },
        {
            key: "getPaused",
            value: function getPaused() {
                return this.get("paused");
            }
        },
        {
            key: "getPlaybackRate",
            value: function getPlaybackRate() {
                return this.get("playbackRate");
            }
        },
        {
            key: "setPlaybackRate",
            value: function setPlaybackRate(playbackRate) {
                return this.set("playbackRate", playbackRate);
            }
        },
        {
            key: "getPlayed",
            value: function getPlayed() {
                return this.get("played");
            }
        },
        {
            key: "getQualities",
            value: function getQualities() {
                return this.get("qualities");
            }
        },
        {
            key: "getQuality",
            value: function getQuality() {
                return this.get("quality");
            }
        },
        {
            key: "setQuality",
            value: function setQuality(quality) {
                return this.set("quality", quality);
            }
        },
        {
            key: "getRemotePlaybackAvailability",
            value: function getRemotePlaybackAvailability() {
                return this.get("remotePlaybackAvailability");
            }
        },
        {
            key: "getRemotePlaybackState",
            value: function getRemotePlaybackState() {
                return this.get("remotePlaybackState");
            }
        },
        {
            key: "getSeekable",
            value: function getSeekable() {
                return this.get("seekable");
            }
        },
        {
            key: "getSeeking",
            value: function getSeeking() {
                return this.get("seeking");
            }
        },
        {
            key: "getTextTracks",
            value: function getTextTracks() {
                return this.get("textTracks");
            }
        },
        {
            key: "getVideoEmbedCode",
            value: function getVideoEmbedCode() {
                return this.get("videoEmbedCode");
            }
        },
        {
            key: "getVideoId",
            value: function getVideoId() {
                return this.get("videoId");
            }
        },
        {
            key: "getVideoTitle",
            value: function getVideoTitle() {
                return this.get("videoTitle");
            }
        },
        {
            key: "getVideoWidth",
            value: function getVideoWidth() {
                return this.get("videoWidth");
            }
        },
        {
            key: "getVideoHeight",
            value: function getVideoHeight() {
                return this.get("videoHeight");
            }
        },
        {
            key: "getVideoUrl",
            value: function getVideoUrl() {
                return this.get("videoUrl");
            }
        },
        {
            key: "getVolume",
            value: function getVolume() {
                return this.get("volume");
            }
        },
        {
            key: "setVolume",
            value: function setVolume(volume) {
                return this.set("volume", volume);
            }
        },
        {
            key: "setTimingSrc",
            value: function() {
                var _setTimingSrc = $a94b7aed81690016$var$_asyncToGenerator(/*#__PURE__*/ $a94b7aed81690016$var$_regeneratorRuntime().mark(function _callee(timingObject, options) {
                    var _this6 = this;
                    var connector;
                    return $a94b7aed81690016$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (timingObject) {
                                    _context.next = 2;
                                    break;
                                }
                                throw new TypeError("A Timing Object must be provided.");
                            case 2:
                                _context.next = 4;
                                return this.ready();
                            case 4:
                                connector = new $a94b7aed81690016$var$TimingSrcConnector(this, timingObject, options);
                                $a94b7aed81690016$var$postMessage(this, "notifyTimingObjectConnect");
                                connector.addEventListener("disconnect", function() {
                                    return $a94b7aed81690016$var$postMessage(_this6, "notifyTimingObjectDisconnect");
                                });
                                return _context.abrupt("return", connector);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function setTimingSrc(_x, _x2) {
                    return _setTimingSrc.apply(this, arguments);
                }
                return setTimingSrc;
            }()
        }
    ]);
    return Player;
}(); // Setup embed only if this is not a node environment
if (!$a94b7aed81690016$var$isNode) {
    $a94b7aed81690016$var$screenfull = $a94b7aed81690016$var$initializeScreenfull();
    $a94b7aed81690016$var$initializeEmbeds();
    $a94b7aed81690016$var$resizeEmbeds();
    $a94b7aed81690016$var$initAppendVideoMetadata();
    $a94b7aed81690016$var$checkUrlTimeParam();
}
var $a94b7aed81690016$export$2e2bcd8739ae039 = $a94b7aed81690016$var$Player;


class $c239475373a9b37e$export$2881499e37b75b9a {
    getEmbed() {
        var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
        if (((_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id) && !this.HTMLElement.querySelector(".embed")) {
            this.__embed = document.createElement("div");
            this.__embed.setAttribute("part", "embed");
            this.__embed.setAttribute("class", "embed");
            setTimeout(()=>this.buildPlayer(), 1);
            return this.__embed;
        } else return false;
    }
    async buildPlayer() {
        if (!this.HTMLElement.root.querySelector(".iframe")) {
            var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
            this.player = null;
            const iframe = document.createElement("iframe");
            iframe.setAttribute("part", "iframe");
            iframe.setAttribute("class", "iframe");
            iframe.setAttribute("type", "text/html");
            iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture; encrypted-media; accelerometer; gyroscope");
            iframe.setAttribute("src", `https://player.vimeo.com/video/${(_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id}?autoplay=1&muted=1&background=1&controls=0&byline=0&dnt=1`);
            this.__embed.appendChild(iframe);
            setTimeout(()=>this.buildPlayer(), 100);
        } else if (!this.player) {
            this.player = new (0, $a94b7aed81690016$export$2e2bcd8739ae039)(this.HTMLElement.root.querySelector(".iframe"));
            this.player.on("loaded", ()=>{
                if (!this.__started) {
                    this.__started = setTimeout(()=>this.fire("ready"), 10000);
                    this.progressObserver_Interval = setInterval(this.progressObserver.bind(this), 100);
                }
            });
        }
    }
    async destroyPlayer() {
        if (this.player && typeof this.player.destroy === "function") this.player.destroy();
    }
    async progressObserver() {
        try {
            if (await this.getDuration() == 0) return 0;
            let p = 100 * await this.getCurrentTime() / await this.getDuration();
            if (p !== this.__progress) {
                if (this.__started && this.__started !== true) {
                    clearTimeout(this.__started);
                    this.__started = true;
                    this.fire("ready");
                }
                this.__progress = p;
                this.fire("progressChange");
            }
        } catch (e) {
            console.error("hapi-player Vimeo provider progressObserver halted");
            clearInterval(this.progressObserver_Interval);
        }
    }
    async getRatio() {
        if (this.player) {
            let w = await this.player.getVideoWidth();
            let h = await this.player.getVideoHeight();
            return w / h;
        }
        return;
    }
    async getDuration() {
        if (this.player && typeof this.player.getDuration === "function") return await this.player.getDuration();
        return 0;
    }
    async playing() {
        if (this.player) return !await this.player.getPaused();
    }
    async play() {
        if (this.player) this.player.play();
    }
    async pause() {
        if (this.player) this.player.pause();
    }
    async getCurrentTime() {
        if (this.player && typeof this.player.getCurrentTime === "function") return await this.player.getCurrentTime();
    }
    async setCurrentTime(seconds) {
        if (this.player) this.player.setCurrentTime(seconds);
    }
    async setVolume(volume) {
        if (this.player) {
            this.__volume = volume;
            this.player.setMuted(volume <= 0);
            this.player.setVolume(volume / 100);
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async getVolume() {
        if (this.player) return 100 * await this.player.getVolume();
        return 0;
    }
    async mute() {
        if (this.player) {
            this.__volume = await this.getVolume();
            this.setVolume(0);
        }
    }
    async unMute(dflt = 100) {
        if (this.player) this.setVolume(this.__volume > 0 || dflt);
    }
    on(eventName, callback) {
        this.events.registerEvent(eventName, callback);
    }
    off(eventName, callback) {
        this.events.unregisterEvent(eventName, callback);
    }
    fire(eventName, data) {
        this.events.fireEvent(eventName, data);
    }
    constructor(HTMLElement){
        this.type = "Vimeo";
        this.HTMLElement = HTMLElement;
        this.events = new (0, $5a22d87987052892$export$2e2bcd8739ae039)(this);
        this.player = null;
        // private state
        this.__volume = null;
        this.__started = null;
        this.__progress = 0;
    }
}
var $c239475373a9b37e$export$2e2bcd8739ae039 = $c239475373a9b37e$export$2881499e37b75b9a;



var $20757f0c74cecc52$var$r = {
    EVENTS: {
        READY: "ready",
        PLAY: "play",
        PAUSE: "pause",
        ENDED: "ended",
        TIMEUPDATE: "timeupdate",
        PROGRESS: "progress",
        SEEKED: "seeked",
        ERROR: "error",
        FULLSCREEN_CHANGE: "fullscreenChange",
        PIP_CHANGE: "pipChange",
        PLAYBACK_RATE_CHANGE: "playbackRateChange",
        AUDIO_CHANGE: "audioChange",
        QUALITY_CHANGE: "qualityChange",
        VOLUME_CHANGE: "volumeChange"
    },
    POST_MESSAGE: !!window.postMessage,
    METHODS: {
        PLAY: "play",
        PAUSE: "pause",
        GETPAUSED: "getPaused",
        MUTE: "mute",
        UNMUTE: "unmute",
        GETMUTED: "getMuted",
        SETVOLUME: "setVolume",
        GETVOLUME: "getVolume",
        GETDURATION: "getDuration",
        SETCURRENTTIME: "setCurrentTime",
        GETCURRENTTIME: "getCurrentTime",
        SETLOOP: "setLoop",
        GETLOOP: "getLoop",
        SETPLAYBACKRATE: "setPlaybackRate",
        GETPLAYBACKRATE: "getPlaybackRate",
        REMOVEEVENTLISTENER: "removeEventListener",
        ADDEVENTLISTENER: "addEventListener"
    },
    DEBUG: !1,
    VERSION: "2.0",
    CONTEXT: "player.js",
    isString: function(o) {
        return Object.prototype.toString.call(o) === "[object String]";
    },
    has: function(o, e) {
        return Object.prototype.hasOwnProperty.call(o, e);
    }
};
$20757f0c74cecc52$var$r.METHODS.all = function() {
    let o = [];
    for(let e in $20757f0c74cecc52$var$r.METHODS)$20757f0c74cecc52$var$r.has($20757f0c74cecc52$var$r.METHODS, e) && $20757f0c74cecc52$var$r.isString($20757f0c74cecc52$var$r.METHODS[e]) && o.push($20757f0c74cecc52$var$r.METHODS[e]);
    return o;
}, $20757f0c74cecc52$var$r.EVENTS.all = function() {
    let o = [];
    for(let e in $20757f0c74cecc52$var$r.EVENTS)$20757f0c74cecc52$var$r.has($20757f0c74cecc52$var$r.EVENTS, e) && $20757f0c74cecc52$var$r.isString($20757f0c74cecc52$var$r.EVENTS[e]) && o.push($20757f0c74cecc52$var$r.EVENTS[e]);
    return o;
}, $20757f0c74cecc52$var$r.addEvent = function(o, e, t) {
    o && (o.addEventListener ? o.addEventListener(e, t, !1) : o.attachEvent ? o.attachEvent("on" + e, t) : o["on" + e] = t);
}, $20757f0c74cecc52$var$r.isNone = function(o) {
    return o == null;
}, $20757f0c74cecc52$var$r.assert = function(o, e) {
    if (!o) throw e || "Player.js Assert Failed";
}, $20757f0c74cecc52$var$r.generateUUID = function() {
    if (crypto && crypto.randomUUID) return crypto.randomUUID();
    {
        let o = URL.createObjectURL(new Blob);
        return o.substring(o.lastIndexOf("/") + 1);
    }
}, $20757f0c74cecc52$var$r.isArray = function(o) {
    return Object.prototype.toString.call(o) === "[object Array]";
};
var $20757f0c74cecc52$var$i = $20757f0c74cecc52$var$r;
var $20757f0c74cecc52$var$h = class {
    has(e, t) {
        if (!Object.hasOwn(this.data, e)) return !1;
        if ($20757f0c74cecc52$var$i.isNone(t)) return !0;
        let n = this.data[e];
        for(let s = 0; s < n.length; s++)if (n[s].id === t) return !0;
        return !1;
    }
    add(e, t, n, s, u) {
        let a = {
            id: e,
            event: t,
            cb: n,
            ctx: s,
            one: u
        };
        this.has(t) ? this.data[t].push(a) : this.data[t] = [
            a
        ];
    }
    execute(e, t, n, s) {
        if (!this.has(e, t)) return !1;
        let u = [], a = [];
        for(let l = 0; l < this.data[e].length; l++){
            let c = this.data[e][l];
            $20757f0c74cecc52$var$i.isNone(t) || !$20757f0c74cecc52$var$i.isNone(t) && c.id === t ? (a.push({
                cb: c.cb,
                ctx: c.ctx ? c.ctx : s,
                data: n
            }), c.one === !1 && u.push(c)) : u.push(c);
        }
        u.length === 0 ? delete this.data[e] : this.data[e] = u;
        for(let l = 0; l < a.length; l++){
            let c = a[l];
            c.cb.call(c.ctx, c.data);
        }
    }
    on(e, t, n, s) {
        this.add(e, t, n, s, !1);
    }
    one(e, t, n, s) {
        this.add(e, t, n, s, !0);
    }
    off(e, t) {
        let n = [];
        if (!Object.hasOwn(this.data, e)) return n;
        let s = [];
        for(let u = 0; u < this.data[e].length; u++){
            let a = this.data[e][u];
            !$20757f0c74cecc52$var$i.isNone(t) && a.cb !== t ? s.push(a) : $20757f0c74cecc52$var$i.isNone(a.id) || n.push(a.id);
        }
        return s.length === 0 ? delete this.data[e] : this.data[e] = s, n;
    }
    constructor(){
        this.data = {};
    }
}, $20757f0c74cecc52$var$v = $20757f0c74cecc52$var$h;
var $20757f0c74cecc52$var$m = [], $20757f0c74cecc52$var$d = class {
    send(e, t, n) {
        if (e.context = $20757f0c74cecc52$var$i.CONTEXT, e.version = $20757f0c74cecc52$var$i.VERSION, t) {
            let s = $20757f0c74cecc52$var$i.generateUUID();
            e.listener = s, this.keeper.one(s, e.method, t, n);
        }
        return !this.isReady && e.value !== "ready" ? (console.debug("Player.queue", e), this.queue.push(e), !1) : (console.debug("Player.send", e, this.origin), this.loaded === !0 && this.elem.contentWindow.postMessage(JSON.stringify(e), this.origin), !0);
    }
    receive(e) {
        if (console.debug("Player.receive", e), e.origin !== this.origin) return !1;
        let t;
        try {
            t = JSON.parse(e.data);
        } catch (n) {
            return !1;
        }
        if (t.context !== $20757f0c74cecc52$var$i.CONTEXT) return !1;
        t.event === "ready" && t.value && t.value.src === this.elem.src && this.ready(t), this.keeper.has(t.event, t.listener) && this.keeper.execute(t.event, t.listener, t.value, this);
    }
    ready(e) {
        if (this.isReady === !0) return !1;
        e.value.events && (this.events = e.value.events), e.value.methods && (this.methods = e.value.methods), this.isReady = !0, this.loaded = !0;
        for(let t = 0; t < this.queue.length; t++){
            let n = this.queue[t];
            console.debug("Player.dequeue", n), e.event === "ready" && this.keeper.execute(n.event, n.listener, !0, this), this.send(n);
        }
        this.queue = [];
    }
    on(e, t, n) {
        let s = $20757f0c74cecc52$var$i.generateUUID();
        return e === "ready" ? this.keeper.one(s, e, t, n) : this.keeper.on(s, e, t, n), this.send({
            method: "addEventListener",
            value: e,
            listener: s
        }), !0;
    }
    off(e, t) {
        let n = this.keeper.off(e, t);
        if (console.debug("Player.off", n), n.length > 0) {
            for(let s in n)this.send({
                method: "removeEventListener",
                value: e,
                listener: n[s]
            });
            return !0;
        }
        return !1;
    }
    supports(e, t) {
        $20757f0c74cecc52$var$i.assert([
            "method",
            "event"
        ].includes(e), 'evtOrMethod needs to be either "event" or "method" got ' + e), t = $20757f0c74cecc52$var$i.isArray(t) ? t : [
            t
        ];
        let n = e === "event" ? this.events : this.methods;
        for(let s = 0; s < t.length; s++)if (!n.includes(t[s])) return !1;
        return !0;
    }
    constructor(e){
        let t = this;
        this.READIED = $20757f0c74cecc52$var$m, $20757f0c74cecc52$var$i.isString(e) && (e = document.getElementById(e)), this.elem = e, $20757f0c74cecc52$var$i.assert(e.nodeName === "IFRAME", 'playerjs.Player constructor requires an Iframe, got "' + e.nodeName + '"'), $20757f0c74cecc52$var$i.assert(e.src, "playerjs.Player constructor requires a Iframe with a 'src' attribute."), this.origin = new URL(e.src).origin, this.keeper = new $20757f0c74cecc52$var$v, this.isReady = !1, this.queue = [], this.events = $20757f0c74cecc52$var$i.EVENTS.all(), this.methods = $20757f0c74cecc52$var$i.METHODS.all(), $20757f0c74cecc52$var$i.POST_MESSAGE ? $20757f0c74cecc52$var$i.addEvent(window, "message", function(n) {
            t.receive(n);
        }) : console.error("Post Message is not Available."), $20757f0c74cecc52$var$m.includes(e.src) ? t.loaded = !0 : this.elem.onload = function() {
            t.loaded = !0;
        };
    }
};
function $20757f0c74cecc52$var$L(o) {
    return function() {
        let e = {
            method: o
        }, t = Array.prototype.slice.call(arguments);
        /^get/.test(o) ? ($20757f0c74cecc52$var$i.assert(t.length > 0, "Get methods require a callback."), t.unshift(e)) : (/^set/.test(o) && ($20757f0c74cecc52$var$i.assert(t.length !== 0, "Set methods require a value."), e.value = t[0]), t = [
            e
        ]), this.send.apply(this, t);
    };
}
for (let o of $20757f0c74cecc52$var$i.METHODS.all())Object.hasOwn($20757f0c74cecc52$var$d.prototype, o) || ($20757f0c74cecc52$var$d.prototype[o] = $20757f0c74cecc52$var$L(o));
$20757f0c74cecc52$var$i.addEvent(window, "message", function(o) {
    let e;
    try {
        e = JSON.parse(o.data);
    } catch (t) {
        return !1;
    }
    if (e.context !== $20757f0c74cecc52$var$i.CONTEXT) return !1;
    e.event === "ready" && e.value && e.value.src && $20757f0c74cecc52$var$m.push(e.value.src);
});
var $20757f0c74cecc52$var$y = $20757f0c74cecc52$var$d;
var $20757f0c74cecc52$var$p = class {
    receive(e) {
        if (e.origin !== this.origin) return !1;
        let t = {};
        if (typeof e.data == "object") t = e.data;
        else try {
            t = window.JSON.parse(e.data);
        } catch (s) {
            console.error("JSON Parse Error", s);
        }
        if (console.debug("Receiver.receive", e, t), !t.method || t.context !== $20757f0c74cecc52$var$i.CONTEXT) return !1;
        if (!$20757f0c74cecc52$var$i.METHODS.all().includes(t.method)) return this.emit("error", {
            code: 2,
            msg: 'Invalid Method "' + t.method + '"'
        }), !1;
        let n = $20757f0c74cecc52$var$i.isNone(t.listener) ? null : t.listener;
        if (t.method === "addEventListener") Object.hasOwn(this.eventListeners, t.value) ? this.eventListeners[t.value].includes(n) || this.eventListeners[t.value].push(n) : this.eventListeners[t.value] = [
            n
        ], t.value === "ready" && this.isReady && this.ready();
        else if (t.method === "removeEventListener") {
            if (Object.hasOwn(this.eventListeners, t.value)) {
                let s = this.eventListeners[t.value].indexOf(n);
                s > -1 && this.eventListeners[t.value].splice(s, 1), this.eventListeners[t.value].length === 0 && delete this.eventListeners[t.value];
            }
        } else this.get(t.method, t.value, n);
    }
    get(e, t, n) {
        let s = this;
        if (!Object.hasOwn(this.methods, e)) return this.emit("error", {
            code: 3,
            msg: 'Method Not Supported"' + e + '"'
        }), !1;
        let u = this.methods[e];
        if (e.substr(0, 3) === "get") {
            let a = function(l) {
                s.send(e, l, n);
            };
            u.call(this, a);
        } else u.call(this, t);
    }
    on(e, t) {
        this.methods[e] = t;
    }
    send(e, t, n) {
        if (console.debug("Receiver.send", e, t, n), this.reject) return console.error("Receiver.send.reject", e, t, n), !1;
        let s = {
            context: $20757f0c74cecc52$var$i.CONTEXT,
            version: $20757f0c74cecc52$var$i.VERSION,
            event: e
        };
        $20757f0c74cecc52$var$i.isNone(t) || (s.value = t), $20757f0c74cecc52$var$i.isNone(n) || (s.listener = n);
        let u = JSON.stringify(s);
        window.parent.postMessage(u, this.origin === "" ? "*" : this.origin);
    }
    emit(e, t) {
        if (!Object.hasOwn(this.eventListeners, e)) return !1;
        console.debug("Instance.emit", e, t, this.eventListeners[e]);
        for(let n = 0; n < this.eventListeners[e].length; n++){
            let s = this.eventListeners[e][n];
            this.send(e, t, s);
        }
        return !0;
    }
    ready() {
        console.debug("Receiver.ready"), this.isReady = !0;
        let e = {
            src: window.location.toString(),
            events: this.supported.events,
            methods: this.supported.methods
        };
        this.emit("ready", e) || this.send("ready", e);
    }
    constructor(e, t){
        let n = this;
        this.isReady = !1, this.origin = new URL(document.referrer).origin, this.methods = {}, this.supported = {
            events: e || $20757f0c74cecc52$var$i.EVENTS.all(),
            methods: t || $20757f0c74cecc52$var$i.METHODS.all()
        }, this.eventListeners = {}, this.reject = !(window.self !== window.top && $20757f0c74cecc52$var$i.POST_MESSAGE), this.reject || $20757f0c74cecc52$var$i.addEvent(window, "message", function(s) {
            n.receive(s);
        });
    }
}, $20757f0c74cecc52$var$f = $20757f0c74cecc52$var$p;
var $20757f0c74cecc52$var$E = class {
    init() {
        let e = {
            duration: 20,
            currentTime: 0,
            interval: null,
            timeupdate: function() {},
            volume: 100,
            mute: !1,
            playing: !1,
            loop: !1,
            play: function() {
                e.interval = setInterval(function() {
                    e.currentTime += .25, e.timeupdate({
                        seconds: e.currentTime,
                        duration: e.duration
                    });
                }, 250), e.playing = !0;
            },
            pause: function() {
                clearInterval(e.interval), e.playing = !1;
            }
        }, t = this.receiver = new $20757f0c74cecc52$var$f;
        t.on("play", function() {
            let n = this;
            e.play(), this.emit("play"), e.timeupdate = function(s) {
                n.emit("timeupdate", s);
            };
        }), t.on("pause", function() {
            e.pause(), this.emit("pause");
        }), t.on("getPaused", function(n) {
            let s = !e.playing;
            n(s);
        }), t.on("getCurrentTime", function(n) {
            n(e.currentTime);
        }), t.on("setCurrentTime", function(n) {
            e.currentTime = n;
        }), t.on("getDuration", function(n) {
            n(e.duration);
        }), t.on("getVolume", function(n) {
            n(e.volume);
        }), t.on("setVolume", function(n) {
            e.volume = n;
        }), t.on("mute", function() {
            e.mute = !0;
        }), t.on("unmute", function() {
            e.mute = !1;
        }), t.on("getMuted", function(n) {
            n(e.mute);
        }), t.on("getLoop", function(n) {
            n(e.loop);
        }), t.on("setLoop", function(n) {
            e.loop = n;
        }), t.on("setPlaybackRate", function(n) {
            e.playbackRate = n;
        }), t.on("getPlaybackRate", function(n) {
            n(e.playbackRate);
        });
    }
    ready() {
        this.receiver.ready();
    }
    constructor(){
        this.init();
    }
}, $20757f0c74cecc52$var$O = $20757f0c74cecc52$var$E;
var $20757f0c74cecc52$var$g = class {
    init(e) {
        $20757f0c74cecc52$var$i.assert(e, "VideoJSReceiver requires a player object");
        let t = this.receiver = new $20757f0c74cecc52$var$f;
        e.on("pause", function() {
            t.emit("pause");
        }), e.on("play", function() {
            t.emit("play");
        }), e.on("timeupdate", function(n) {
            let s = e.currentTime(), u = e.duration();
            if (!s || !u) return !1;
            let a = {
                seconds: s,
                duration: u
            };
            t.emit("timeupdate", a);
        }), e.on("ended", function() {
            t.emit("ended");
        }), e.on("error", function() {
            t.emit("error");
        }), t.on("play", function() {
            e.play();
        }), t.on("pause", function() {
            e.pause();
        }), t.on("getPaused", function(n) {
            n(e.paused());
        }), t.on("getCurrentTime", function(n) {
            n(e.currentTime());
        }), t.on("setCurrentTime", function(n) {
            e.currentTime(n);
        }), t.on("getDuration", function(n) {
            n(e.duration());
        }), t.on("getVolume", function(n) {
            let s = e.volume() * 100;
            n(s);
        }), t.on("setVolume", function(n) {
            e.volume(n / 100);
        }), t.on("mute", function() {
            e.volume(0);
        }), t.on("unmute", function() {
            e.volume(1);
        }), t.on("getMuted", function(n) {
            let s = e.volume() === 0;
            n(s);
        }), t.on("getLoop", function(n) {
            n(e.loop());
        }), t.on("setLoop", function(n) {
            e.loop(n);
        }), t.on("setPlaybackRate", function(n) {
            e.playbackRate(n);
        }), t.on("getPlaybackRate", function(n) {
            n(e.playbackRate());
        });
    }
    ready() {
        this.receiver.ready();
    }
    constructor(e){
        this.init(e);
    }
}, $20757f0c74cecc52$var$S = $20757f0c74cecc52$var$g;
var $20757f0c74cecc52$var$T = class {
    init(e) {
        $20757f0c74cecc52$var$i.assert(e, "HTML5Adapter requires a video element");
        let t = this.receiver = new $20757f0c74cecc52$var$f;
        e.addEventListener("playing", function() {
            t.emit("play");
        }), e.addEventListener("pause", function() {
            t.emit("pause");
        }), e.addEventListener("ended", function() {
            t.emit("ended");
        }), e.addEventListener("timeupdate", function() {
            t.emit("timeupdate", {
                seconds: e.currentTime,
                duration: e.duration
            });
        }), e.addEventListener("progress", function() {
            t.emit("buffered", {
                percent: e.buffered.length
            });
        }), t.on("play", function() {
            e.play();
        }), t.on("pause", function() {
            e.pause();
        }), t.on("getPaused", function(n) {
            n(e.paused);
        }), t.on("getCurrentTime", function(n) {
            n(e.currentTime);
        }), t.on("setCurrentTime", function(n) {
            e.currentTime = n;
        }), t.on("getDuration", function(n) {
            n(e.duration);
        }), t.on("getVolume", function(n) {
            let s = e.volume * 100;
            n(s);
        }), t.on("setVolume", function(n) {
            e.volume = n / 100;
        }), t.on("mute", function() {
            e.muted = !0;
        }), t.on("unmute", function() {
            e.muted = !1;
        }), t.on("getMuted", function(n) {
            n(e.muted);
        }), t.on("getLoop", function(n) {
            n(e.loop);
        }), t.on("setLoop", function(n) {
            e.loop = n;
        }), t.on("setPlaybackRate", function(n) {
            e.playbackRate = n;
        }), t.on("getPlaybackRate", function(n) {
            n(e.playbackRate);
        });
    }
    ready() {
        this.receiver.ready();
    }
    constructor(e){
        this.init(e);
    }
}, $20757f0c74cecc52$var$R = $20757f0c74cecc52$var$T;
var $20757f0c74cecc52$var$N = {
    Player: $20757f0c74cecc52$var$y,
    Receiver: $20757f0c74cecc52$var$f,
    MockAdapter: $20757f0c74cecc52$var$O,
    VideoJSAdapter: $20757f0c74cecc52$var$S,
    HTML5Adapter: $20757f0c74cecc52$var$R,
    CONTEXT: $20757f0c74cecc52$var$i.CONTEXT,
    VERSION: $20757f0c74cecc52$var$i.VERSION,
    METHODS: $20757f0c74cecc52$var$i.METHODS,
    addEvent: $20757f0c74cecc52$var$i.addEvent
};
typeof window < "u" && (window.playerjs = $20757f0c74cecc52$var$N);
var $20757f0c74cecc52$export$2e2bcd8739ae039 = $20757f0c74cecc52$var$N;


class $d9e9a23f7b1e2c4b$export$2881499e37b75b9a {
    getEmbed() {
        var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
        if (((_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id) && !this.HTMLElement.querySelector(".embed")) {
            this.__embed = document.createElement("div");
            this.__embed.setAttribute("part", "embed");
            this.__embed.setAttribute("class", "embed");
            setTimeout(()=>this.buildPlayer(), 1);
            return this.__embed;
        } else return false;
    }
    async buildPlayer() {
        if (!this.HTMLElement.root.querySelector(".iframe")) {
            var _this_HTMLElement_settings_embed, _this_HTMLElement_settings, _this_HTMLElement;
            this.player = null;
            const iframe = document.createElement("iframe");
            iframe.setAttribute("part", "iframe");
            iframe.setAttribute("class", "iframe");
            iframe.setAttribute("type", "text/html");
            iframe.setAttribute("allow", "accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;");
            iframe.setAttribute("src", `https://play.gumlet.io/embed//${(_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : (_this_HTMLElement_settings_embed = _this_HTMLElement_settings.embed) === null || _this_HTMLElement_settings_embed === void 0 ? void 0 : _this_HTMLElement_settings_embed.id}?preload=true&autoplay=true&loop=true&disable_player_controls=true`);
            this.__embed.appendChild(iframe);
            setTimeout(()=>this.buildPlayer(), 100);
        } else if (!this.player) {
            this.player = new (0, $20757f0c74cecc52$export$2e2bcd8739ae039).Player(this.HTMLElement.root.querySelector(".iframe"));
            this.player.on("ready", ()=>{
                this.player.isReady = true;
                if (!this.__started) {
                    this.__started = setTimeout(()=>this.fire("ready"), 1000);
                    this.progressObserver_Interval = setInterval(this.progressObserver.bind(this), 100);
                }
            });
        }
    }
    async destroyPlayer() {
        if (this.player && typeof this.player.destroy === "function") this.player.destroy();
    }
    async progressObserver() {
        try {
            if (await this.getDuration() == 0) return 0;
            let p = 100 * await this.getCurrentTime() / await this.getDuration();
            if (p !== this.__progress) {
                if (this.__started && this.__started !== true) {
                    clearTimeout(this.__started);
                    this.__started = true;
                    this.fire("ready");
                }
                this.__progress = p;
                this.fire("progressChange");
            }
        } catch (e) {
            console.error(e);
            console.error("hapi-player Gumlet provider progressObserver halted");
            clearInterval(this.progressObserver_Interval);
        }
    }
    async getRatio() {
        var _this_HTMLElement_settings, _this_HTMLElement;
        return (_this_HTMLElement = this.HTMLElement) === null || _this_HTMLElement === void 0 ? void 0 : (_this_HTMLElement_settings = _this_HTMLElement.settings) === null || _this_HTMLElement_settings === void 0 ? void 0 : _this_HTMLElement_settings.embed.ratio;
    }
    async getDuration() {
        if (this.player && typeof this.player.getDuration === "function") return new Promise((resolve, reject)=>this.player.getDuration((value)=>{
                resolve(value);
            }));
        return 0;
    }
    async playing() {
        if (this.player) return !await this.player.getPaused();
    }
    async play() {
        if (this.player) this.player.play();
    }
    async pause() {
        if (this.player) this.player.pause();
    }
    async getCurrentTime() {
        if (this.player && typeof this.player.getCurrentTime === "function") return new Promise((resolve, reject)=>this.player.getCurrentTime((value)=>{
                resolve(value);
            }));
    }
    async setCurrentTime(seconds) {
        if (this.player) this.player.setCurrentTime(seconds);
    }
    async setVolume(volume) {
        if (this.player) {
            this.__volume = volume;
            if (volume <= 0) this.player.mute(volume <= 0);
            else this.player.unmute(volume <= 0);
            this.player.setVolume(volume);
            setTimeout(()=>this.fire("volumeChange"), 10);
        }
    }
    async getVolume() {
        if (this.player) return new Promise((resolve, reject)=>this.player.getVolume((value)=>{
                resolve(value);
            }));
        return 0;
    }
    async mute() {
        if (this.player) {
            this.__volume = await this.getVolume();
            this.setVolume(0);
        }
    }
    async unMute(dflt = 100) {
        if (this.player) this.setVolume(this.__volume > 0 || dflt);
    }
    on(eventName, callback) {
        this.events.registerEvent(eventName, callback);
    }
    off(eventName, callback) {
        this.events.unregisterEvent(eventName, callback);
    }
    fire(eventName, data) {
        this.events.fireEvent(eventName, data);
    }
    constructor(HTMLElement){
        this.type = "Gumlet";
        this.HTMLElement = HTMLElement;
        this.events = new (0, $5a22d87987052892$export$2e2bcd8739ae039)(this);
        this.player = null;
        // private state
        this.__volume = null;
        this.__started = null;
        this.__progress = 0;
    }
}
var $d9e9a23f7b1e2c4b$export$2e2bcd8739ae039 = $d9e9a23f7b1e2c4b$export$2881499e37b75b9a;


var $69572849623311d1$exports = {};
$69572849623311d1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M512 256c0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0s256 114.6 256 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9v176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z\"/></svg>";


var $77f11ff8f212f94d$exports = {};
$77f11ff8f212f94d$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256s114.6 256 256 256zm-32-320v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v128c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z\"/></svg>";


var $5652a30fa70026e1$exports = {};
$5652a30fa70026e1$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><path d=\"M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8c54.2-44 88.7-111 88.7-186.2s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5c21.5 17.6 35.4 44.4 35.4 74.5s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64v384c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z\"/></svg>";


var $0aab6cec7584a850$exports = {};
$0aab6cec7584a850$exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 512\"><path d=\"M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-88-69C582.8 365 608 313.4 608 256c0-60.1-27.7-113.8-70.9-149-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C539.3 170.7 560 210.9 560 256s-20.7 85.3-53.2 111.8c-.9.7-1.7 1.5-2.4 2.3l-43.6-34.2c5.5.1 11.1-1.6 15.7-5.4 21.6-17.6 35.5-44.4 35.5-74.5s-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C457.1 227.6 464 241 464 256s-6.9 28.4-17.7 37.3c-7.6 6.2-10.4 16-8 24.9L384 275.7V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3l-115.9 103-176-138zM64 224v64c0 35.3 28.7 64 64 64h67.8l134.9 119.9c9.4 8.4 22.9 10.4 34.4 5.3S384 460.6 384 448v-49.5L93.8 169.9C75.9 181.2 64 201.2 64 224z\"/></svg>";


var $c7148588c3c792c1$var$__firstInterractionReady = false;
const $c7148588c3c792c1$var$__instances = new Set();
class $c7148588c3c792c1$var$hapVideo extends HTMLElement {
    connectedCallback() {
        // if shadowRoot is set there is nothing to do
        if (!!this.shadowRoot) return;
        this.flushStorage();
        $c7148588c3c792c1$var$__instances.add(this);
        this.style.display = this.style.display || "block";
        this.style.width = this.style.width || "100%";
        this.style.height = this.style.height || "100%";
        this.shadow = this.attachShadow({
            mode: "open"
        });
        this.shadow.innerHTML = `
			<style>${$06588c507189b8b5$exports}</style>
			<div class="root" part="root">
				<div class="ctrls" part="ctrls">
					<button class="ctrls-play" part="ctrls-play" type="button">${0, (/*@__PURE__*/$parcel$interopDefault($69572849623311d1$exports))}</button>
					<button class="ctrls-pause" part="ctrls-pause" type="button">${0, (/*@__PURE__*/$parcel$interopDefault($77f11ff8f212f94d$exports))}</button>
					<div class="ctrls-progress" part="ctrls-progress"></div>
					<button class="ctrls-mute" part="ctrls-mute" type="button">${0, (/*@__PURE__*/$parcel$interopDefault($5652a30fa70026e1$exports))}</button>
					<button class="ctrls-unmute" part="ctrls-unmute" type="button">${0, (/*@__PURE__*/$parcel$interopDefault($0aab6cec7584a850$exports))}</button>
					<div class="ctrls-volume" part="ctrls-volume"></div>
				</div>
				<div class="loader" part="loader"></div>
				<div class="gdpr" part="gdpr"></div>
				<div class="video" part="video">
					<div class="wrapper" part="wrapper"></div>
				</div>
				<div class="placeholder" part="placeholder"></div>
			</div>
			`;
        this.root = this.shadow.querySelector(".root");
        setTimeout(this.__init.bind(this), 500);
    }
    __init() {
        console.log("__init");
        this.settings = {
            provider: this.getAttribute("provider"),
            gdpr: this.hasAttribute("gdpr") ? true : false,
            cover: this.hasAttribute("cover") ? true : false,
            height: this.getAttribute("height") || "inherit",
            loop: this.__parseLoop(),
            autoplay: this.hasAttribute("autoplay") ? true : false,
            clickable: this.hasAttribute("clickable") ? true : false,
            muted: this.hasAttribute("muted") ? true : false,
            controls: this.getAttribute("controls") || this.hasAttribute("controls") || false,
            placeholder: this.getAttribute("placeholder") || this.hasAttribute("placeholder") || false,
            embed: {
                id: this.getAttribute("embed-id"),
                ratio: this.__parseRatio(this.getAttribute("embed-ratio"))
            }
        };
        if (this.settings.placeholder) this.root.querySelector(".placeholder").style.backgroundImage = 'url("' + this.settings.placeholder + '")';
        setTimeout(this.__rgpd_watcher.bind(this), 10);
    }
    __rgpd_watcher() {
        console.log("__rgpd_watcher");
        this.settings.gdpr = this.hasAttribute("gdpr") ? true : false;
        if (this.settings.gdpr) {
            this.root.setAttribute("gdpr", "");
            setTimeout(this.__rgpd_watcher.bind(this), 250);
        } else {
            this.root.removeAttribute("gdpr");
            this.root.setAttribute("loading", "");
            setTimeout(this.__build.bind(this), 10);
        }
    }
    __build() {
        console.log("__build");
        this.__ready = false;
        this.__looping = false;
        this.__seeking = false;
        if (this.settings.provider == "native") this.provider = new (0, $3adfe98124662902$export$2881499e37b75b9a)(this);
        else if (this.settings.provider == "youtube") this.provider = new (0, $15607a07c80ee7b5$export$2881499e37b75b9a)(this);
        else if (this.settings.provider == "vimeo") this.provider = new (0, $c239475373a9b37e$export$2881499e37b75b9a)(this);
        else if (this.settings.provider == "gumlet") this.provider = new (0, $d9e9a23f7b1e2c4b$export$2881499e37b75b9a)(this);
        if (this.provider) {
            this.__fixRatio_Interval = setInterval(()=>this.__fixRatio(), 100);
            this.provider.on("ready", (function() {
                if (this.settings.provider == "vimeo") setTimeout(()=>this.root.removeAttribute("loading"), 500);
                else if (this.settings.provider == "gumlet") setTimeout(()=>this.root.removeAttribute("loading"), 500);
                else if (this.settings.provider == "youtube") setTimeout(()=>this.root.removeAttribute("loading"), 2000);
                else setTimeout(()=>this.root.removeAttribute("loading"), 100);
                this.root.setAttribute("ready", "");
                this.__fixRatio(this.provider);
                this.__ready = true;
                this.onReady();
            }).bind(this));
            this.provider.on("progressChange", async ()=>{
                this.root.style.setProperty("--video-progression", await this.getProgress() + "%");
                this.__loopEnd();
                this.__seekEnd();
                // loop analysis
                let loop = this.settings.loop;
                if (typeof loop === "object" && loop.length === 2) {
                    let time = await this.getCurrentTime();
                    if (time < loop[0] || time >= loop[1]) this.__loopStart(loop[0]);
                }
                if (loop === true) // prevent unleash the hell on earth by looping before the last second
                {
                    if (await this.getCurrentTime() >= await this.getDuration() - 1) this.__loopStart(0);
                }
            });
            this.provider.on("volumeChange", async ()=>{
                this.root.style.setProperty("--video-volume", await this.getVolume() + "%");
            });
            if (this.settings.controls) this.root.setAttribute("controls", this.settings.controls);
            let wrapper = this.root.querySelector(".wrapper");
            let embed = this.provider.getEmbed();
            wrapper.appendChild(embed);
            //console.log(wrapper,embed);
            this.root.querySelector(".video").addEventListener("click", (event)=>{
                if (this.settings.clickable) this.toggle();
            });
            this.root.querySelector(".ctrls").addEventListener("click", (event)=>{
                event.stopPropagation();
            });
            this.root.querySelector(".ctrls-play").addEventListener("click", (event)=>{
                this.play();
            });
            this.root.querySelector(".ctrls-pause").addEventListener("click", (event)=>{
                this.pause();
            });
            this.root.querySelector(".ctrls-mute").addEventListener("click", (event)=>{
                this.mute();
            });
            this.root.querySelector(".ctrls-unmute").addEventListener("click", (event)=>{
                this.unMute();
            });
            this.root.querySelector(".ctrls-progress").addEventListener("click", (event)=>{
                event.stopPropagation();
                const x = event.offsetX;
                const w = event.currentTarget.clientWidth;
                if (x >= 0 && x <= w) this.setProgress(x / w * 100);
            });
            this.root.querySelector(".ctrls-volume").addEventListener("click", (event)=>{
                event.stopPropagation();
                const x = event.offsetX;
                const w = event.currentTarget.clientWidth;
                if (x >= 0 && x <= w) this.setVolume(x / w * 100);
            });
            window.addEventListener("resize", this.__fixRatio.bind(this));
        }
    }
    disconnectedCallback() {
        if (this.provider && typeof this.provider.destroyPlayer === "function") this.provider.destroyPlayer();
    }
    async onReady() {
        if (this.__ready) {
            console.log("onReady");
            this.mute();
            if (this.settings.autoplay) {
                this.setCurrentTime(0);
                this.start();
            } else this.pause();
            if ($c7148588c3c792c1$var$__firstInterractionReady) {
                console.log("__firstInterractionReady");
                if (!this.settings.muted && await this.getVolume() == 0) await this.unMute();
            }
        }
    }
    flushStorage() {
        var store = JSON.parse(window.localStorage.getItem("hapi-video-userpref")) || {};
        Object.entries(store).forEach((data, k)=>{
            if (data.time < Date.now() / 1000) delete store[k];
        });
        window.localStorage.setItem("hapi-video-userpref", JSON.stringify(store));
    }
    setStorage(k, v, ttl = 900) {
        k = this.settings.provider + "_" + this.settings.embed.id + "::" + k;
        var store = JSON.parse(window.localStorage.getItem("hapi-video-userpref")) || {};
        store[k] = {
            value: v,
            expire: Date.now() / 1000 + ttl
        };
        window.localStorage.setItem("hapi-video-userpref", JSON.stringify(store));
    }
    getStorage(k, dflt) {
        k = this.settings.provider + "_" + this.settings.embed.id + "::" + k;
        var store = JSON.parse(window.localStorage.getItem("hapi-video-userpref")) || {};
        if (store[k] && store[k].expire > Date.now() / 1000) return store[k].value !== undefined ? store[k].value : dflt;
        else if (store[k]) {
            delete store[k];
            window.localStorage.setItem("hapi-video-userpref", JSON.stringify(store));
        }
    }
    async toggle() {
        if (this.provider && typeof this.provider.playing === "function") {
            if (await this.provider.playing()) this.pause();
            else this.play();
        }
    }
    async start() {
        if (this.provider && typeof this.provider.play === "function") {
            let loop = this.settings.loop;
            if (typeof loop === "object" && loop.length === 2) this.setCurrentTime(loop[0]);
            this.play();
        }
    }
    async play() {
        if (this.provider && typeof this.provider.play === "function") {
            this.root.classList.add("playing");
            this.provider.play();
        }
    }
    async pause() {
        if (this.provider && typeof this.provider.pause === "function") {
            this.root.classList.remove("playing");
            this.provider.pause();
        }
    }
    async mute() {
        if (this.provider && typeof this.provider.mute === "function") {
            this.root.classList.add("muted");
            this.provider.mute();
        }
    }
    async unMute() {
        if (this.provider && typeof this.provider.unMute === "function") {
            this.root.classList.remove("muted");
            this.provider.unMute(this.getStorage("volume", 50));
        }
    }
    async setVolume(volume) {
        if (this.provider && typeof this.provider.setVolume === "function") {
            this.setStorage("volume", volume);
            this.root.classList.remove("muted");
            this.provider.setVolume(volume);
        }
    }
    async getVolume() {
        if (this.provider && typeof this.provider.getVolume === "function") return await this.provider.getVolume();
        return 0;
    }
    async getProgress() {
        let time = await this.getCurrentTime();
        let duration = await this.getDuration();
        let loop = this.settings.loop;
        if (typeof loop === "object" && loop.length === 2) {
            duration = loop[1] - loop[0];
            time = time - loop[0];
        }
        if (duration) return 100 * time / duration;
        return 0;
    }
    async setProgress(p) {
        let duration = await this.getDuration();
        let delta = 0;
        let loop = this.settings.loop;
        if (typeof loop === "object" && loop.length === 2) {
            duration = loop[1] - loop[0];
            delta = loop[0];
        }
        this.setCurrentTime(delta + duration * p / 100);
    }
    async getRatio() {
        if (this.provider && typeof this.provider.getRatio === "function") return await this.provider.getRatio();
        return "16:9";
    }
    async getDuration() {
        if (this.provider && typeof this.provider.getDuration === "function") return await this.provider.getDuration();
        return 0;
    }
    async getCurrentTime() {
        if (this.provider && typeof this.provider.getCurrentTime === "function") return await this.provider.getCurrentTime();
        return 0;
    }
    async setCurrentTime(seconds) {
        if (this.provider && typeof this.provider.setCurrentTime === "function") {
            this.__seekStart();
            this.provider.setCurrentTime(seconds);
        }
    }
    __loopStart(seconds) {
        clearTimeout(this.__looping);
        this.__looping = setTimeout(()=>this.root.setAttribute("looping", ""), 250);
        this.pause();
        this.setCurrentTime(seconds);
    }
    __loopEnd() {
        if (this.__looping) {
            clearTimeout(this.__looping);
            this.__looping = false;
            this.root.removeAttribute("looping");
            this.play();
        }
    }
    __seekStart() {
        clearTimeout(this.__seeking);
        this.__seeking = setTimeout(()=>this.root.setAttribute("seeking", ""), 250);
    }
    __seekEnd() {
        if (this.__seeking) {
            clearTimeout(this.__seeking);
            this.__seeking = false;
            this.root.removeAttribute("seeking");
            this.play();
        }
    }
    __parseLoop() {
        let loopString = this.getAttribute("loop") || "";
        if (loopString && loopString.trim().match(/^[0-9.]+:[0-9.]+$/)) {
            let r = loopString.trim().split(":");
            return [
                parseFloat(r[0]),
                parseFloat(r[1])
            ].sort((a, b)=>a - b);
        }
        return this.hasAttribute("loop");
    }
    __parseRatio(ratioString) {
        if (ratioString && ratioString.trim().match(/^[0-9.]+:[0-9.]+$/)) {
            let r = ratioString.trim().split(":");
            let w = 1 * r[0];
            let h = 1 * r[1];
            if (h > 0) return w / h;
        }
        return 16 / 9;
    }
    async __fixRatio(provider) {
        try {
            let w = 100;
            let h = 100;
            console.log(this.settings);
            if (this.settings.height !== "inherit") {
                if (this.settings.height === "ratio") {
                    var eRatio = false;
                    try {
                        var eRatio = await this.getRatio();
                    } catch (e) {
                    // nothing to do here
                    }
                    if (eRatio > 0) {
                        this.style.height = this.clientWidth / eRatio + "px";
                        this.style.position = "relative";
                    }
                } else if (this.settings.height) {
                    this.style.height = this.settings.height;
                    this.style.position = "relative";
                }
            }
            if (this.settings.cover && this.root.clientHeight > 0) {
                var ratio = this.root.clientWidth / this.root.clientHeight;
                var eRatio = await this.getRatio();
                if (ratio < eRatio) w = w * eRatio / ratio;
                else h = h * ratio / eRatio;
            }
            this.root.querySelector(".wrapper").style.width = w + "%";
            this.root.querySelector(".wrapper").style.height = h + "%";
        } catch (e) {
            console.error("hapi-player __fixRatio halted", e);
            clearInterval(this.__fixRatio_Interval);
        }
    }
}
customElements.define("hapi-video", $c7148588c3c792c1$var$hapVideo);
function $c7148588c3c792c1$var$firstInterraction() {
    if (!$c7148588c3c792c1$var$__firstInterractionReady) {
        $c7148588c3c792c1$var$__firstInterractionReady = true;
        $c7148588c3c792c1$var$__instances.forEach((i)=>{
            i.onReady();
        });
    }
}
document.addEventListener("mousedown", $c7148588c3c792c1$var$firstInterraction);
document.addEventListener("touchstart", $c7148588c3c792c1$var$firstInterraction);
document.addEventListener("keydown", $c7148588c3c792c1$var$firstInterraction);

})();
//# sourceMappingURL=hapi-video.js.map
